import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { child, DataOrderService, OrderStatus, OrderStatusCodeEnum, OrderStatusCodes, TrackingLinkOrder, isPickupOrderType } from 'app/shared/services/data-order.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertSnackbarComponent } from 'app/shared/components/alert-snackbar/alert-snackbar.component';
import { MatSelectChange } from '@angular/material/select';
import { UberService } from 'app/shared/services/uber/uber.service';
import {
  AdditionalActions,
  ADMIN_OPTIONS,
  BulkActionStatus,
  MASTER_STATUSES,
  OrderActions,
  OrderActionType,
  OrderAssignStatusEnum,
  OrderOptions,
  OrdersTableStatus,
  OrderStatusEnum,
  STATUS_ALIASES,
  USER_OPTIONS,
  DOCTOR_CUSTOM_STATUSES,
  ShiftAssignStatusEnum
} from 'app/shared/helpers/status-options.helper';
import { PAYMENT_STATUS_MAP, PaymentStatusValue } from 'app/shared/helpers/payment-status-map.helper';
import { MatDialog } from '@angular/material/dialog';
import moment, { Moment } from 'moment-timezone';
import { Observable, Subscription, of } from 'rxjs';
import { switchMap, tap, catchError, debounceTime, distinctUntilChanged, take, defaultIfEmpty, filter, map } from 'rxjs/operators';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { DialogConfirmationComponent } from '../dialog-confirmation/dialog-confirmation.component';
import {
  SurveyDataObj,
  SourceEnum,
  TELEHEALTH_BOOKING_TYPE,
  TELEHEALTH_BOOKING_TYPE_COLORS,
  TELEHEALTH_CLASS_MAP,
  TelehealthClassEnum,
  isSurveyDataObj,
} from 'app/shared/models/surveyData.model';
import { NoteType } from 'app/shared/interfaces/utility-types';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckbox } from '@angular/material/checkbox';
import { OrderActionPanelService } from 'app/shared/services/order-action-panel.service';
import {
  USER_VERIFICATION_MAP,
  UserVerificationObj,
  UserVerificationStatus,
} from 'app/shared/helpers/user-verification-map.helper';
import { DialogCancelOrderComponent } from '../dialog-cancel-order/dialog-cancel-order.component';
import { unescapeNewlineChars } from 'app/shared/helpers/utils';
import { UserService } from 'app/shared/services/user.service';
import { ProfileType, UserRole } from 'app/shared/enums/profile-type.enum';
import { SettingsResponse, SystemSettingsService } from 'app/shared/services/system-settings.service';
import { DialogCreateFollowUpRequestComponent } from '../dialog-create-follow-up-request/dialog-create-follow-up-request.component';
import { capitalizeEachWord, shouldCreateFollowUpAppointment, isOrderTypePickUp } from 'app/shared/helpers/utils';
import { AlertService } from 'app/shared/services/alert/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MenuItem } from 'app/shared/components/menu-item/menu-item.component';
import { MatDatepicker, MatDatepickerInputEvent, MatDateRangeInput } from '@angular/material/datepicker';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

import { ManageShiftsService } from 'app/shared/services/manage-shifts/manage-shifts.service';
import { ShiftStatusResponse } from 'app/shared/models/shift.model';
import { prepareTime } from 'app/shared/helpers/time.helper';
import { ConsultOutcomeStatus, EscalationReason } from '../view-orders/view-orders.component';
import { DialogPreviewDocumentComponent } from '../order-documents/dialog-preview-document/dialog-preview-document.component';
import { DialogOutOfScopeComponent } from '../dialog-out-of-scope/dialog-out-of-scope.component';
import { config } from 'config';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { AllocationGroup } from 'app/shared/helpers/status-options.helper';

export enum EscalationStatus {
  NORMAL = 'normal',
  ESCALATED = 'escalated',
  MAX_ESCALATED = 'max_escalated'
}

export const Order_STATUS_COLOR_MAP = {
  [OrderAssignStatusEnum.Started]: '#AAC4FF',
  [OrderAssignStatusEnum.Assigned]: '#8957e5',
  [OrderAssignStatusEnum.Escalated]: '#F0A04B',
  [OrderAssignStatusEnum.UnAssinged]: '#0a2756',
  [OrderAssignStatusEnum.Paused]: '#A9A9A9',
  [OrderAssignStatusEnum.Completed]: '#97CB90'
}

export interface OrderData {
  paper_script_email_sent: string;
  paper_script_location_has_email: boolean;
  orderAssignmentNotes: string;
  escalatedNote: string;
  showUnassignClinicianOption: boolean;
  shiftOrderId: number;
  selectedClinician: Clinician;
  createdDate: string;
  lastModified: string;
  orderType: string;
  deliveryPartnerName: any;
  deliveryType: any;
  orderId: number;
  deliveryDateTime: string;
  uniqueOrderId: string;
  firstName: string;
  lastName: string;
  locationname: string;
  source: string;
  locationstatus: number;
  suburb: string;
  currentorderstatus: string;
  currentOwner: string;
  type: number;
  userPrefferedDate: string;
  orderStatus: OrderStatus;
  created_At: string;
  mobile: string;
  delivery_Tracking: any;
  orderTotal: string;
  paymentStatus: string;
  locationId: number;
  enduserid: number;
  postcode: string;
  script: number;
  non_Script: number;
  item_codes: string;
  timeDif: string;
  totalDiff: string;
  delivery_instructions: string;
  addr1: string;
  deliverymobile: any;
  addr2: any;
  addsuburb: string;
  addstate: string;
  addpostcode: string;
  latitude: string;
  longitude: string;
  user_verification_status: any;
  selected?: boolean;
  survey_data?: SurveyDataObj;
  booking_time?: Moment;
  booking_timezone?: string;
  importantSurveyData?: ImportantSurveyData[];
  status_code?: number;
  statusCodeName?: string;
  rowBackgroundColor?: string;
  orderPaidAmount?: string;
  order_class: string;
  availableClinicians: Clinician[];
  assignedClincianDetails: Clinician;
  order_assign_status?: OrderAssignStatusEnum;
  actionText: string;
  isScriptAdded: boolean;
  patientName: string;
  consult_outcome: string | null;
  paper_script_location: number | null;
  isPaperScriptAdded: boolean;
  external_reference_id: string | null;
  escalation_count?: number;
  last_escalation_reason?: string;
  last_escalated_at?: string;
  last_escalation_reason_text?: string;
  last_escalation_sub_reason?: string;
  escalation_status?: string;
  clinician_notes?: string;
  is_video_consult?: number | string;
  order_service_profiles?: number[];
  group_id?: number;
  group_name?: string;
  pending_booking_reminder_sent_at?: string | null;
}

export interface clinicianDetails {
  id: number,
  name: string
}
export interface ClinicianBillingProfile {
  name: string;
  value: 'hour' | 'consult';
}
export interface Clinician {
  id?: number;
  name: string;
  shiftId?: number;
  service_profiles?: number[];
  number_of_active_orders?: number;
  billing_profile?: ClinicianBillingProfile['value'];
  in_consult?: 0 | 1;
  experience?: string;
  max_consult_allocation?: number;
  bat_appointments?: Array<{ order_id: number; time: string }>;
  number_of_pharmacy_consults?: number;
  number_of_priority_consults?: number;
  number_of_urgent_consults?: number;
  out_of_scope_escalated_orders?: number[];
  profileTypeId?: number | string;
  bypassAllocationRules?: boolean;
}

type ImportantSurveyData = {
  label: string;
  value: any;
  bold?: boolean;
};

const MAX_SELECTION_ALLOWED = 50;

type StatuConfig = {
  [statusProp: string]: {
    status: string;
    filters: string[];
    actions: string[];
    columns: {
      [R in UserRole]?: string[];
    };
  };
};

@Component({
    selector: 'app-orders-table',
    templateUrl: './orders-table.component.html',
    styleUrls: ['./orders-table.component.scss'],
    standalone: false
})

export class OrdersTableComponent implements OnInit, OnDestroy {
  serviceRequest: any;
  dataSource: MatTableDataSource<OrderData>;
  // The static option in @ViewChild determines when the query is resolved.
  // Setting it to false resolves  after ngAfterViewInit.
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  @ViewChild('datePicker', { static: false }) datePicker!: MatDatepicker<Date>;

  startDate: string
  endDate: string
  resultsLength = 0;
  filterBox = '';
  admin: any;
  pageEvent: PageEvent;
  pageIndex: number = 1;
  pageSize: number = 50;
  from: number = 0;
  to: number = 0;
  firstPage: number = 1;
  currentPage: number;
  lastPage: number = 1;
  length: number = 0;
  pageOffset: number;
  displayedColumns: string[];
  @ViewChild('selectAll') selectAllTrigger: MatCheckbox;
  @ViewChildren('doorDashiFrameTriggers') doorDashiFrameTriggers: QueryList<ElementRef>;
  @ViewChildren('doorDashiFrames') doorDashiFrames: QueryList<ElementRef>;
  @Input('status') status: OrdersTableStatus = OrdersTableStatus.PendingApproval;
  @Input('business-type') businessType: string = 'All';
  @Input('order-class') orderClass;
  @Input('allow-bulk-action') allowBulkAction: boolean = false;

  loading: boolean = false;
  isLoadingOrders: boolean = false;
  getServerDataSubscription: Subscription;
  options: OrderOptions = null;
  isMobile: boolean;
  screenSizeWatcher: Subscription;
  selection = new SelectionModel<OrderData>(true, []);
  orderStatusArr: string[] = MASTER_STATUSES;
  doctorOrderStatus: OrderStatus[] = DOCTOR_CUSTOM_STATUSES;

  // currentOwner = new FormControl('');
  orderPanelSubscriptions: Subscription[] = [];
  canelThing: any

  //date selection parameters
  range = new UntypedFormGroup({
    start: new UntypedFormControl(''),
    end: new UntypedFormControl(''),
  });

  // Search control
  searchControl = new UntypedFormControl('');

  static readonly DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'

  statuses: StatuConfig = {
    care_call: {
      status: 'Exception,Bulk Status Transition,Pending Batch Processing,New,Waiting For Info,Rejected,Pending Payment,Process,Waiting Room,Waiting For Review,Awaiting Authorisation,Request Issued,Clinic To Action,Clinic To Review,Auto Allocation',
      filters: [
        'Auto Allocation',
        'Waiting Room',
        'Clinic To Action',
        'Clinic To Review',
        'Waiting For Info'
      ],
      actions: ['Change Pharmacy', 'Accept', 'Reject', 'New'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.SuperAdmin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    pending_approval: {
      status: 'New,Rejected,Pharmacy To Review',
      filters: [
        'New',
        'Rejected',
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Follow Up',
        'RefrHealth'
      ],
      actions: ['Change Pharmacy', 'Accept', 'Reject', 'New'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    pending_approval_in_store: {
      status: 'New,Rejected,Pharmacy To Review',
      filters: [
        'New',
        'Rejected',
        'Pharmacy To Review',
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'RefrHealth'
      ],
      actions: ['Change Pharmacy', 'Accept', 'Reject', 'New'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    price_request: {
      status: 'Waiting For Review,Awaiting Authorisation',
      filters: [
        'Waiting For Review',
        'Awaiting Authorisation',
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Follow Up',
        'RefrHealth'
      ],
      actions: ['Change Pharmacy', 'Awaiting Authorisation', 'Process', 'Cancel'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    processing: {
      status: 'Process,Request Issued',
      filters: [
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Waiting For Review',
        'Awaiting Delivery',
        'In Transit',
        'Exception',
        'Returned Delivery',
        'Check Delivery Status',
        'Completed',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    pending_cancellation: {
      status: 'Pending Cancellation',
      filters: [
        'Telehealth',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Waiting For Review',
        'Awaiting Delivery',
        'In Transit',
        'Exception',
        'Returned Delivery',
        'Check Delivery Status',
        'Completed',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    processing_admin: {
      status: 'Process,Pending Cancellation',
      filters: [
        'Process',
        'Pending Cancellation',
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Waiting For Review',
        'Awaiting Delivery',
        'In Transit',
        'Exception',
        'Returned Delivery',
        'Check Delivery Status',
        'Completed',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    deliverypickup: {
      status:
        'Awaiting Delivery,In Transit,Awaiting Pickup,Pending Batch Processing,Pending Return,Left at LPO,Return',
      filters: [
        'Awaiting Delivery',
        'In Transit',
        'Awaiting Pickup',
        'Pending Batch Processing',
        'Pending Returned Delivery',
        'Left at LPO',
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'Returned Delivery',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'RefrHealth'
      ] as OrderStatus[],
      actions: [
        'In Transit',
        'Completed',
        'Pending Batch Processing',
        'Process',
        'Exception',
        'Returned Delivery',
        'Cancel',
        'Check Delivery Status',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    deliverypickup_driver: {
      status: 'Awaiting Delivery,In Transit',
      filters: ['Awaiting Delivery', 'In Transit'],
      actions: ['In Transit', 'Completed', 'Returned Delivery'],
      columns: {
        Driver: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    completed: {
      status: 'Completed',
      filters: [
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'In Store',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'Care Call',
        'RefrHealth'
      ],
      actions: ['Process', 'Returned Delivery', 'Exception', 'Cancelled'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.TelehealthPharmacy]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.ClinicalOperations]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.Doctor]: [
          'source',
          'name',
          'orderid',
          'orderstatus',
          'action',
        ],
        [ProfileType.Nurse]: [
          'source',
          'name',
          'orderid',
          'orderstatus',
          'action',
        ],
        [ProfileType.NursePractitioner]: [
          'source',
          'name',
          'orderid',
          'orderstatus',
          'action',
        ],
      },
    },
    cancelled: {
      status: 'Cancelled',
      filters: [
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'In Store',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'Care Call',
        'RefrHealth'
      ],
      actions: ['Process', 'Returned Delivery', 'Exception', 'Cancelled'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.TelehealthPharmacy]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.ClinicalOperations]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.Doctor]: [
          'source',
          'name',
          'orderid',
          'orderstatus',
          'action',
        ],
        [ProfileType.Nurse]: [
          'source',
          'name',
          'orderid',
          'orderstatus',
          'action',
        ],
        [ProfileType.NursePractitioner]: [
          'source',
          'name',
          'orderid',
          'orderstatus',
          'action',
        ],
      },
    },
    active: {
      status:
        'Pharmacy To Review,Clinic To Review,Clinic To Action,Request Issued,New,Rejected,Awaiting Delivery,In Transit,Awaiting Pickup,Pending Batch Processing,Pending Return,Left at LPO,Process,Waiting For Review,Awaiting Authorisation,Pending Cancellation,Return,Bulk Status Transition,Waiting For Info,Auto Allocation,Clinic To Update,Waiting Room,Returned',
      filters: [
        'Pharmacy To Review',
        'Clinic To Review',
        'Clinic To Action',
        'Request Issued',
        'New',
        'Rejected',
        'Awaiting Delivery',
        'In Transit',
        'Awaiting Pickup',
        'Pending Batch Processing',
        'Pending Returned Delivery',
        'Left at LPO',
        'Process',
        'Waiting For Review',
        'Awaiting Authorisation',
        'Pending Cancellation',
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'Uber',
        'Medical Certificate',
        'Returned',
        'Clinic To Update',
        'Waiting Room',
        'Waiting For Info',
        'Bulk Status Transition',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Process',
        'Waiting For Review',
        'Pending Cancellation',
        'Awaiting Authorisation',
        'Awaiting Delivery',
        'Awaiting Pickup',
        'New',
        'In Transit',
        'Exception',
        'Returned Delivery',
        'Check Delivery Status',
        'Completed',
        'Cancel',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'bookingTime',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'bookingTime',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'bookingTime',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'bookingTime',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    exception: {
      status: 'Exception,Pending Payment,Return',
      filters: [
        'Exception',
        'Pending Payment',
        'Returned Delivery',
        'PharmaProgram',
        'Follow Up',
        'RefrHealth'
      ],
      actions: ['Cancel', 'Process', 'Awaiting Authorisation'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    pharmacy_to_review: {
      status: 'Pharmacy To Review',
      filters: [
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Clinic To Review',
        'Pending Cancellation',
        'Exception',
        'Check Delivery Status',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    clinic_to_review: {
      status: 'Clinic To Review',
      filters: [
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Medical Certificate',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Clinic To Action',
        'Exception',
        'Pending Cancellation',
        'Cancelled',
        'Check Delivery Status',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    clinic_to_action: {
      status:
        'Clinic To Review,Clinic To Action,Clinic To Update,Waiting For Info,Waiting Room,Auto Allocation',
      filters: [
        'Clinic To Review',
        'Clinic To Action',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Request Issued',
        'Exception',
        'Pending Cancellation',
        'Cancelled',
        'Check Delivery Status',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'bookingTime',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.Doctor]: [
          'source',
          'important',
          'preview',
          'orderstatus',
          'action',
        ],
        [ProfileType.Nurse]: [
          'source',
          'important',
          'preview',
          'orderstatus',
          'action',
        ],
        [ProfileType.NursePractitioner]: [
          'source',
          'important',
          'preview',
          'orderstatus',
          'action',
        ],
      },
    },
    clinic_to_action_admin: {
      status: 'Clinic To Action',
      filters: [
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Medical Certificate',
        'Priority',
        'MentalHealth',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Request Issued',
        'Exception',
        'Pending Cancellation',
        'Cancelled',
        'Check Delivery Status',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'bookingTime',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
      },
    },
    request_issued: {
      status: 'Request Issued',
      filters: [
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Medical Certificate',
        'Priority',
        'MentalHealth',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [
        'Change Pharmacy',
        'Exception',
        'Check Delivery Status',
        'Completed',
        'Pending Cancellation',
        'Cancelled',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.Doctor]: [
          'source',
          'orderDetails',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.Nurse]: [
          'source',
          'orderDetails',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.NursePractitioner]: [
          'source',
          'orderDetails',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
      },
    },
    pending_batch_processing: {
      status: OrderStatusEnum.PendingBatchProcessing,
      filters: [
        'Telehealth',
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Market Place',
        'In Store',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Follow Up',
        'RefrHealth'
      ],
      actions: ['New', 'Cancelled', 'Check Delivery Status'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    clinic_to_update: {
      status: 'Clinic To Update',
      filters: [
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.Doctor]: [
          'source',
          'orderDetails',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.Nurse]: [
          'source',
          'orderDetails',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
        [ProfileType.NursePractitioner]: [
          'source',
          'orderDetails',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
      },
    },
    waiting_room: {
      status: 'Waiting Room',
      filters: [
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'bookingTime',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
      },
    },
    auto_allocation: {
      status: 'Auto Allocation',
      filters: [
        'Chemistree',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
      },
    },

    waiting_for_information: {
      status: 'Waiting For Info',
      filters: [
        'Chemistree',
        'Huru',
        'Botanist',
        'Health Engine',
        'Priority',
        'MentalHealth',
        'Lumi',
        'WeightLoss',
        'PharmaProgram',
        'Incomplete Info',
        'Follow Up',
        'RefrHealth'
      ],
      actions: [],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'owner',
          'action',
        ],
      },
    },
    escalation: {
      status: 'Exception,Bulk Status Transition,Pending Batch Processing,New,Waiting For Info,Rejected,Pending Payment,Process,Waiting Room,Waiting For Review,Awaiting Authorisation,Request Issued,Clinic To Action,Clinic To Review,Auto Allocation',
      filters: [
        // 'Auto Allocation',
        // 'Waiting Room',
        // 'Clinic To Action',
        // 'Clinic To Review',
        // 'Waiting For Info'
      ],
      actions: ['Change Pharmacy', 'Accept', 'Reject', 'New'],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
      },
    },
    telehealth_pending: {
      status:
        'Clinic To Review,Clinic To Action,Waiting Room,Clinic To Update,Waiting For Info,Auto Allocation',
      filters: [],
      actions: [
        'Change Pharmacy',
        'Request Issued',
        'Exception',
        'Pending Cancellation',
        'Cancelled',
        'Check Delivery Status',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'orderid',
          'totalStatus',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'orderid',
          'totalStatus',
          'important',
          'clinician',
          'orderstatus',
          'action',
        ],
        [ProfileType.TelehealthPharmacy]: [
          'createddate',
          'source',
          'orderid',
          'totalStatus',
          'important',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.ClinicalOperations]: [
          'createddate',
          'source',
          'orderid',
          'totalStatus',
          'important',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'orderid',
          'totalStatus',
          'important',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'orderid',
          'totalStatus',
          'important',
          'ordertype',
          'orderstatus',
          'action',
        ],
      },
    },
    telehealth_request_issued: {
      status: 'Request Issued',
      filters: [],
      actions: [
        'Change Pharmacy',
        'Exception',
        'Check Delivery Status',
        'Completed',
        'Pending Cancellation',
        'Cancelled',
      ],
      columns: {
        [ProfileType.Admin]: [
          'createddate',
          'source',
          'orderDetails',
          'totalStatus',
          'important',
          'orderstatus',
          'clinician',
          'owner',
          'action',
        ],
        [ProfileType.PortalUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.TelehealthPharmacy]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.ClinicalOperations]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.SuperBusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
        [ProfileType.BusinessUser]: [
          'createddate',
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      }
    },
    // MT-1110: dispensed telehealth orders waiting for the delivery team to add a tracking link
    telehealth_awaiting_delivery: {
      status: 'Awaiting Delivery',
      filters: [],
      actions: [],
      columns: {
        [ProfileType.TelehealthPharmacy]: [
          'source',
          'name',
          'orderid',
          'totalStatus',
          'ordertype',
          'orderstatus',
          'action',
        ],
      }
    },
  };

  custom_filters: string[] = [
    'Telehealth',
    'Chemistree',
    'Huru',
    'Botanist',
    'Health Engine',
    'Priority',
    'MentalHealth',
    'Market Place',
    'Uber',
    'Direct',
    'In Store',
    'Medical Certificate',
    'Lumi',
    'WeightLoss',
    'PharmaProgram',
    'Incomplete Info',
    'Follow Up',
    'Care Call',
    'RefrHealth'
  ];

  isDriver: boolean;

  orderStatusCodes: OrderStatusCodes = {} as OrderStatusCodes;
  consultWaitTime: SettingsResponse['settings'] = {}

  private startedOrderIndex: number = -1;
  private assignedOrderIndex: number = -1;

  isOrderAssignStatusChipVisible: boolean = false;

  today = moment(new Date());

  private subscriptions: Subscription = new Subscription();

  filtersConfig: any[] = [];
  filterForm: UntypedFormGroup = new UntypedFormGroup({});
  filterSearchText: Map<string, string> = new Map();
  private filteredOptionsMap: Map<string, any[]> = new Map();
  readonly FILTER_SEARCH_THRESHOLD = 10; // Show search when options > this number

  constructor(
    public dataOrder: DataOrderService,
    private uberService: UberService,
    private router: Router,
    private route: ActivatedRoute,
    public jwtAuth: JwtAuthService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private mediaObserver: MediaObserver,
    private orderPanelService: OrderActionPanelService,
    private userService: UserService,
    private systemSettingsService: SystemSettingsService,
    private alertService: AlertService,
    private manageShiftService: ManageShiftsService,
    private loader: AppLoaderService
  ) {
    this.admin = this.jwtAuth.isAdmin() ? '1' : '0';
  }

  isRowsDisabled(): boolean {
    return this.manageShiftService.isActionDisabledForClinician() && this.status === OrdersTableStatus.ClinicToAction;
  }

  private refreshOrdersListener = (event: any) => {
    const filters = this.getCurrentFilters();
    this.getServerData(filters.status, filters.filter);
  };


  getOrderStatusChipsColor(status: string): string {
    return Order_STATUS_COLOR_MAP[status as OrderAssignStatusEnum] || '';
  }

  ngOnInit() {
    this.isOrderAssignStatusChipVisible = this.isOrderAssignStatusChipVisibleForUser()
    window.addEventListener('refreshOrders', this.refreshOrdersListener);
    if (this.jwtAuth.isClinician()) {
      this.getEarlyStartThreshold();
    }
    this.isDriver = this.jwtAuth.isDriver();
    this.options = this.admin === '1' ? ADMIN_OPTIONS : USER_OPTIONS;
    this.setDisplayedColumns();
    this.restoreDateFilterFromUrl();
    // Filter initialization now handled by loadFilters() method which uses data-order.service as single source of truth
    if (this.jwtAuth.getUser().role === 'User') {
      this.router.navigate(['/products/active']);
    }
    this.checkMobileView();

    // Load status codes before filters/server data so rows get their colour on first load
    // (restores the sequencing from 2ae74c81a, dropped by merge e76c01308).
    this.getOrderStatusCodes().pipe(take(1), defaultIfEmpty(undefined)).subscribe(() => {
      this.loadFilters();
    });

    // Setup debounced search
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.dataSource.filter = (value || '').trim().toLowerCase();
        if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage();
        }
      });
  }
  ngAfterViewInit() {
    // Data loading is now handled in loadFilters() after filters are initialized
    // This prevents race condition between filter initialization and data fetching
  }

  ngOnDestroy() {
    window.removeEventListener('refreshOrders', this.refreshOrdersListener);
    if (this.screenSizeWatcher) {
      this.screenSizeWatcher.unsubscribe();
    }

    //reset order panel service
    if (this.orderPanelService) {
      this.orderPanelService.reset();
    }

    this._snackBar?.dismiss();

    this.unsubscribeToOrderPanelSubscriptions();
    this.subscriptions.unsubscribe();
  }


  updateShiftStatus(orderId: number, onSuccess: () => void) {
    const data = {
      shiftOrderId: orderId,
      status: OrderAssignStatusEnum.Started
    }
    this.dataOrder.updateClinicianShiftOrderStatus(data).subscribe(
      res => {
        if (res.status == 200) {
          this.alertService.notifySuccess(res.msg);
          const filters = this.getCurrentFilters();
          this.getServerData(filters.status, filters.filter);
          onSuccess();
        };
      },
      (err: HttpErrorResponse) => {
        this.alertService.notifyError(err.error.msg)
        const filters = this.getCurrentFilters();
        this.getServerData(filters.status, filters.filter);
      })
  }

  updateOrderIndices() {
    const data = this.dataSource.data;
    this.startedOrderIndex = data.findIndex(order => order.order_assign_status === OrderAssignStatusEnum.Started);
    this.assignedOrderIndex = data.findIndex(order => order.order_assign_status === OrderAssignStatusEnum.Assigned);

    // Update action text for all orders based on new availability rules
    data.forEach((order, index) => {
      order.actionText = this.getActionText(order);
    });
  }

  getRowClass(element: OrderData, index: number) {
    if (!(this.jwtAuth.isClinician() && this.status === OrdersTableStatus.ClinicToAction)) {
      return;
    }

    const isStartedOrderPresent = this.startedOrderIndex !== -1;
    let shouldBlur = false;

    if (isStartedOrderPresent) {
      // If there's a started order, blur all others except the started one
      shouldBlur = index !== this.startedOrderIndex;
    } else {
      // Check if this order can be started based on new chronological rules
      const canStart = this.isOrderAvailableToStart(element, index);

      // Blur orders that cannot be started (including paused orders with booking time restrictions)
      shouldBlur = !canStart;
    }

    return shouldBlur ? { 'blurred-row': true } : {};
  }

  /**
   * Finds the next chronologically available order that can be started.
   * Returns the index of the next available order, or -1 if none available.
   */
  private getNextAvailableOrderIndex(dataArray?: OrderData[]): number {
    if (!(this.jwtAuth.isClinician() && this.status === OrdersTableStatus.ClinicToAction)) {
      return -1;
    }

    // Use provided dataArray or fallback to dataSource.data
    const data = dataArray || this.dataSource?.data;
    if (!data || data.length === 0) {
      return -1;
    }

    // If there's a started order, no other order can be started
    if (this.startedOrderIndex !== -1) {
      return -1;
    }

    const currentTime = moment();
    const availableOrders: { index: number; order: OrderData; sortTime: moment.Moment }[] = [];

    // Collect all potentially available orders (only assigned orders for chronological sequence)
    data.forEach((order, index) => {
      // Only include assigned orders in chronological ordering calculation
      // Paused orders should not block the chronological sequence
      if (order.order_assign_status !== OrderAssignStatusEnum.Assigned) {
        return;
      }

      // For orders with booking time, check if they can be started based on early start threshold
      if (order.booking_time && moment.isMoment(order.booking_time) && order.booking_time.isValid()) {
        const bookingTime = order.booking_time;
        const minutesUntilBooking = bookingTime.diff(currentTime, 'minutes');

        // Get early start threshold for this order
        const earlyStartThreshold = this.getEarlyStartThresholdForOrder(order);

        // Only restrict future appointments that haven't reached the early start window
        if (minutesUntilBooking > earlyStartThreshold) {
          return;
        }

        // Use booking time for sorting
        availableOrders.push({
          index,
          order,
          sortTime: bookingTime
        });
      } else {
        // For orders without booking time, use creation time
        const createdTime = moment(order.created_At);
        if (createdTime.isValid()) {
          availableOrders.push({
            index,
            order,
            sortTime: createdTime
          });
        }
      }
    });

    // Sort orders: prioritize those with booking times, then by time (earliest first)
    availableOrders.sort((a, b) => {
      const aHasBookingTime = a.order.booking_time && moment.isMoment(a.order.booking_time) && a.order.booking_time.isValid();
      const bHasBookingTime = b.order.booking_time && moment.isMoment(b.order.booking_time) && b.order.booking_time.isValid();

      // If one has booking time and the other doesn't, prioritize the one with booking time
      if (aHasBookingTime && !bHasBookingTime) {
        return -1;
      }
      if (!aHasBookingTime && bHasBookingTime) {
        return 1;
      }

      // If both have same booking time status, sort by time (earliest first)
      return a.sortTime.diff(b.sortTime);
    });

    // Return the index of the highest priority available order
    return availableOrders.length > 0 ? availableOrders[0].index : -1;
  }

  /**
   * Gets the early start threshold for a specific order
   */
  private getEarlyStartThresholdForOrder(element: OrderData): number {
    const source = element?.source ?? '';
    const telehealthType = element?.survey_data?.header?.telehealth_type ?? '';
    const locationId = element?.locationId ?? '';

    const keyPrefix = 'early_start_threshold_';
    const earlyStartKeys = [
      `${keyPrefix}${locationId}`,                      // Highest priority
      `${keyPrefix}${source}_${telehealthType}`,       // Source + Telehealth type
      `${keyPrefix}${source}`,                         // Source only
      `${keyPrefix}${telehealthType}`,                 // Telehealth type only
    ];

    // Default fallback threshold
    const defaultThreshold = Number(this.consultWaitTime[`${keyPrefix}default`]?.settingvalue) || 5;
    let earlyStartThreshold = defaultThreshold;

    for (const key of earlyStartKeys) {
      const setting = this.consultWaitTime[key];
      if (setting?.settingvalue) {
        earlyStartThreshold = Number(setting.settingvalue);
        break;
      }
    }

    return earlyStartThreshold;
  }

  /**
   * Checks if a specific order can be started based on simple chronological rules
   */
  isOrderAvailableToStart(orderData: OrderData, index: number, dataArray?: OrderData[]): boolean {
    if (!(this.jwtAuth.isClinician() && this.status === OrdersTableStatus.ClinicToAction)) {
      return true; // Non-clinicians or other statuses can access all orders
    }

    // If there's a started order, only that order can be accessed
    if (this.startedOrderIndex !== -1) {
      return index === this.startedOrderIndex;
    }

    // Allow doctors to start any assigned order in their queue
    // Rule 1: Any assigned order can be started (if no order is currently started)
    if (orderData.order_assign_status === OrderAssignStatusEnum.Assigned) {
      return true;
    }

    // Rule 2: Paused orders can always be resumed
    if (orderData.order_assign_status === OrderAssignStatusEnum.Paused) {
      return true;
    }

    // All other orders are not available
    return false;
  }

  getActionText(orderData: OrderData): string {
    if (this.jwtAuth.isClinician()) {
      if (this.status === OrdersTableStatus.Completed) {
        return 'View Order';
      }
      else if (orderData.order_assign_status === OrderAssignStatusEnum.Assigned) {
        return 'Start Consultation';
      }
      else if (orderData.order_assign_status === OrderAssignStatusEnum.Paused) {
        return 'Resume'
      }
      else {
        return capitalizeEachWord(orderData.order_assign_status);
      }
    }

    return 'View Order';
  }

  setDisplayedColumns() {
    let columns = this.statuses[this.status].columns[this.jwtAuth.role];
    // Fallback to Admin columns for SuperAdmin if SuperAdmin columns not defined
    if (!columns && this.jwtAuth.role === ProfileType.SuperAdmin) {
      columns = this.statuses[this.status].columns[ProfileType.Admin];
    }
    if (this.allowBulkAction && this.admin === '1') {
      columns.unshift('select');
    }
    if (this.jwtAuth.isTelehealthPharmacyUser()) {
      columns = columns?.filter(column => column !== 'createddate');
    }
    this.displayedColumns = columns;
  }

  checkMobileView() {
    this.isMobile = this.mediaObserver.isActive('xs');
    // flex-layout 14 removed `media$`. It was `asObservable()` piped through exactly
    // this filter+map, so keeping the pipe preserves the pre-upgrade behaviour.
    this.screenSizeWatcher = this.mediaObserver
      .asObservable()
      .pipe(
        filter((changes: MediaChange[]) => changes.length > 0),
        map((changes: MediaChange[]) => changes[0])
      )
      .subscribe((change: MediaChange) => {
        this.isMobile = change.mqAlias == 'xs';
      });
  }

  filterCopyArray(arr: string[], include = false) {
    if (!include) return [...this.orderStatusArr].filter(item => !arr.includes(item));
    return [...this.orderStatusArr].filter(item => arr.includes(item));
  }

  getdeliveryType(type, name) {
    return type === 'Delivery' ? name : type;
  }

  isOrderEscalated(element: OrderData): boolean {
    return element.escalation_status === EscalationStatus.ESCALATED ||
      element.escalation_status === EscalationStatus.MAX_ESCALATED;
  }

  isMaxEscalated(element: OrderData): boolean {
    return element.escalation_status === EscalationStatus.MAX_ESCALATED;
  }


  getEscalationCount(element: OrderData): number {
    return element.escalation_count;
  }

  getEscalationChipClasses(element: OrderData): string {
    const baseClasses = 'escalation-chip mm-order-status-chip';
    const severityClass = this.isMaxEscalated(element) ? 'escalation-chip--max' : 'escalation-chip--normal';
    return `${baseClasses} ${severityClass}`;
  }

  getEscalationReasonClasses(element: OrderData): string {
    const baseClasses = 'escalation-reason mm-my-2';
    const severityClass = this.isMaxEscalated(element) ? 'escalation-reason--max' : 'escalation-reason--normal';
    return `${baseClasses} ${severityClass}`;
  }

  openDeliveryTracking(url) {
    if (url == null) return;
    window.open(url, '_blank');
  }
  _actions(orderData: OrderData) {
    const status = orderData.orderStatus;
    const deliveryPartnerName = orderData.deliveryPartnerName;
    if (this.jwtAuth.isTelehealthPharmacyUser() && this.status === OrdersTableStatus.TelehealthRequestIssued)
      return [AdditionalActions.Dispense];
    if (this.jwtAuth.isTelehealthPharmacyUser() && this.status === OrdersTableStatus.TelehealthAwaitingDelivery)
      return [AdditionalActions.AddTrackingLink];
    if (!this.options[status]) return [];
    if (this.jwtAuth.isPharmacyUser() && this.status === 'telehealth_pending') return [];
    if (this.jwtAuth.isPharmacyUser() && this.status === 'telehealth_request_issued')
      return ['Completed'];

    let res = [...(this.options[status].actions || [])];

    if (deliveryPartnerName && deliveryPartnerName.includes('Uber')) {
      res.push('Check Delivery Status');
    }
    if (shouldCreateFollowUpAppointment(status, orderData)) {
      res.push(OrderActions.CreateFollowUpAppointment);
    }

    // Add "Change BAT Appointment" option for BAT appointments
    if (this.dataOrder.shouldShowChangeBatAppointment(orderData, orderData.survey_data)) {
      res.push(AdditionalActions.ChangeBatAppointment);
    }

    // Add "Change to Book A Time" option for Next Available appointments
    if (this.dataOrder.shouldShowChangeNaToBat(orderData, orderData.survey_data)) {
      res.push(AdditionalActions.ChangeNaToBat);
    }

    // Don't show "Move to Urgent" if order is already in Priority Escalation group
    if (orderData.group_id === AllocationGroup.PriorityEscalationOrder) {
      res = res.filter(action => action !== OrderActions.MoveToUrgent);
    }

    return res;
  }

  actionAlias(action: OrderActionType, orderStatus: OrderStatus): OrderActionType {
    if (orderStatus === 'Rejected' && action === 'Cancel') {
      return 'Cancel';
    }
    return (STATUS_ALIASES[action]?.alias as OrderActionType) ?? action;
  }

  //find if every order in the status options helper has no actions
  //using this to align the launch icon correctly
  hasNoActions() {
    if (this.jwtAuth.isPharmacyUser() && this.status === 'telehealth_pending') return true;
    return this.dataSource.data.every(
      order => this.options[order.orderStatus]?.actions.length === 0
    );
  }


  dateChanged(e: MatDatepickerInputEvent<Moment>) {
    if (!e.value) return

    const start: Moment = this.range.get('start').value;
    const end: Moment = this.range.get('end').value;

    if (start && end) {
      this.startDate = start.startOf('day').format(OrdersTableComponent.DATE_FORMAT);
      this.endDate = end.endOf('day').format(OrdersTableComponent.DATE_FORMAT)
      this.updateUrlParams();
    }

    // Date filter will be applied when Apply Filters button is clicked
  }

  onClinicianChange(selectedClinician: any, order: OrderData) {
    if (selectedClinician?.id && selectedClinician?.out_of_scope_escalated_orders?.includes(order.orderId)) {
      const dialogRef = this.dialog.open(DialogConfirmationComponent, {
        width: '450px',
        disableClose: true,
        data: {
          headerText: 'Confirm Reassignment',
          message: `This order was previously escalated as Out of Scope by ${selectedClinician.name}. Are you sure you want to reassign this order to the same clinician?`,
          confirmButtonText: 'Reassign',
          showCancelButton: true
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 1) {
          this.performClinicianAssignment(selectedClinician, order);
        } else {
          const filters = this.getCurrentFilters();
          this.getServerData(filters.status, filters.filter);
        }
      });
    } else {
      this.performClinicianAssignment(selectedClinician, order);
    }
  }

  private performClinicianAssignment(selectedClinician: any, order: OrderData) {
    const data: any = {
      orderId: order.orderId,
    };

    if (selectedClinician?.isUnassign) {
      data.isUnassign = true;
      this.dataOrder.assignOrderToClinician(data).subscribe(
        res => {
          if (res.status === 200) {
            this.alertService.notifySuccess(res.msg);
          }
          const filters = this.getCurrentFilters();
          this.getServerData(filters.status, filters.filter);
        },
        (err: HttpErrorResponse) => {
          if (err.error?.msg && typeof err.error?.msg === 'object') {
            let errorMessage = '';
            Object.keys(err.error.msg).forEach(key => {
              errorMessage += `${key}: ${err.error.msg[key].join(', ')}\n`;
            });
            this.alertService.notifyError(errorMessage);
          } else {
            this.alertService.notifyError(err.error?.msg || 'An unexpected error occurred');
          }
          const filters = this.getCurrentFilters();
          this.getServerData(filters.status, filters.filter);
        }
      );
      return;
    } else if (selectedClinician?.id) {
      data.clinicianId = selectedClinician.id;
      data.shiftId = selectedClinician.shiftId;
      if (selectedClinician.bypassAllocationRules) {
        data.bypassAllocationRules = true;
      }
    } else {
      return;
    }

    this.dataOrder
      .confirmClinicianAssignmentByServiceProfile(
        order.order_service_profiles,
        selectedClinician?.service_profiles
      )
      .pipe(take(1))
      .subscribe(shouldProceed => {
        if (!shouldProceed) {
          const filters = this.getCurrentFilters();
          this.getServerData(filters.status, filters.filter);
          return;
        }

        this.dataOrder.assignOrderToClinician(data).subscribe(
          res => {
            if (res.status === 200) {
              this.alertService.notifySuccess(res.msg);
            }
            const filters = this.getCurrentFilters();
            this.getServerData(filters.status, filters.filter);
          },
          (err: HttpErrorResponse) => {
            if (err.error?.msg && typeof err.error?.msg === 'object') {
              let errorMessage = '';
              Object.keys(err.error.msg).forEach(key => {
                errorMessage += `${key}: ${err.error.msg[key].join(', ')}\n`;
              });
              this.alertService.notifyError(errorMessage);
            } else {
              this.alertService.notifyError(err.error?.msg || 'An unexpected error occurred');
            }
            const filters = this.getCurrentFilters();
            this.getServerData(filters.status, filters.filter);
          }
        );
      });
  }

  getServerData(status = this.statuses[this.status].status, filter: string = '') {
    // Prevent concurrent calls
    if (this.isLoadingOrders) {
      console.log('getServerData already in progress, skipping...');
      return;
    }

    this.isLoadingOrders = true;
    this.loader.open('Loading orders...', { width: '200px', closable: true })
      .subscribe(() => {
        this.isLoadingOrders = false;
        this.getServerDataSubscription?.unsubscribe();
      });
    let payload_statuses = status;
    let payload_filter = filter;

    let data = {
      statuses: payload_statuses,
      filter: payload_filter,
      type: this.jwtAuth.isClinician() ? 'all_classes' : this.orderClass,
      perPage: this.pageSize,
      page: this.pageIndex,
    };

    if (this.startDate && this.endDate && this.shouldShowDateFilter) {
      data['start_date'] = this.startDate;
      data['end_date'] = this.endDate;
    }

    if (filter) {
      try {
        const filterObj = JSON.parse(filter);
        if (filterObj.clinicianId) {
          data['clinicianId'] = filterObj.clinicianId;
          delete filterObj.clinicianId;
          data['filter'] = JSON.stringify(filterObj);
        }
      } catch (e) {
      }
    }

    if (typeof this.orderClass !== 'undefined') {
      if (this.orderClass === 'online') {
        data['orderClass'] =
          'Medmate,Telehealth Online,Telehealth Prepaid,Telehealth Claim,Telehealth In Store';
      } else if (this.orderClass === 'in_store') {
        data['orderClass'] = 'Telehealth In Store';
      } else if (this.orderClass === 'all_classes') {
        data['orderClass'] =
          'Medmate,Telehealth Online,Telehealth Prepaid,Telehealth Claim,Telehealth In Store';
      }
    }

    this.getServerDataSubscription = this.dataOrder.getOrderList(data).subscribe(
      res => {
        try {
          res[0].data.forEach((el: OrderData) => {
            if (typeof el.survey_data === 'string') {
              el.survey_data = this.prepareSurveyData(el.survey_data);
            }
            el.patientName = this.preparePatientName(el.survey_data);

            if (el.booking_time) {
              if (typeof el.booking_time === 'string') {
                el.booking_time = prepareTime(el.booking_time, this.jwtAuth.getRole());
              }
            } else if (el.survey_data?.header?.appointment_slot) {
              el.booking_time = moment(el.survey_data.header.appointment_slot);
            }

            el.importantSurveyData = this.prepareImportantSurveyData(el);
            el.rowBackgroundColor = this.orderStatusCodes[el.status_code]?.colour;
            el.statusCodeName = this.orderStatusCodes[el.status_code]?.name;
            el.showUnassignClinicianOption = this.shouldShowUnassignOption(el);
            el.orderAssignmentNotes = this.getOrderAssignStatusText(el);
            el.availableClinicians = el.availableClinicians?.filter(clinician => clinician.id !== el.selectedClinician?.id);

            // el.userVerification = this.userService.verificationObj(el.user_verification_status as UserVerificationStatus)
          });

          this.dataSource = new MatTableDataSource(res[0].data);

          // Set actionText after dataSource is created so getActionText can access the data properly
          // res[0].data.forEach((el: OrderData, index: number) => {
          //   el.actionText = this.getActionTextWithData(el, index, res[0].data);
          // });
          this.dataSource.sortData = this.sortData;
          this.dataSource.sort = this.sort;
          this.from = res[0].from;
          this.to = res[0].to;
          this.length = res[0].total;
          this.currentPage = res[0].current_page;
          this.lastPage = res[0].last_page;
          this.dataSource.filterPredicate = function (data, filter: string): boolean {
            filter = filter.toString().trim().toLowerCase();

            // Helper to safely convert and check field
            const matchField = (field: any): boolean => {
              if (!field) return false;
              return field.toString().trim().toLowerCase().includes(filter);
            };

            return (
              // Order status and type
              matchField(data.orderStatus) ||
              matchField(data.currentorderstatus) ||
              matchField(data.orderType) ||
              matchField(data.statusCodeName) ||

              // Patient/Customer details
              matchField(data.firstName) ||
              matchField(data.lastName) ||
              matchField(data.patientName) ||
              matchField(data.mobile) ||

              // Order identifiers
              data.uniqueOrderId.toString().includes(filter) ||
              data.orderId.toString().includes(filter) ||
              matchField(data.external_reference_id) ||

              // Location details
              matchField(data.locationname) ||
              matchField(data.source) ||

              // Clinician details
              matchField(data.currentOwner) ||
              matchField(data.selectedClinician?.name) ||
              matchField(data.assignedClincianDetails?.name) ||

              // Other details
              matchField(data.consult_outcome)
            );
          };

          this.updateOrderIndices();
        } catch (error) {
          console.error('Error processing order data:', error);
        } finally {
          this.isLoadingOrders = false;
          this.loader.close();
        }
      },
      error => {
        console.error('Error fetching orders:', error);
        this.alertService.notifyError('Failed to load orders. Please try again.');
        this.isLoadingOrders = false;
        this.loader.close();
      }
    );
  }

  sortData(items: OrderData[], sort: MatSort): OrderData[] {
    if (!sort.active || sort.direction === '') {
      return items;
    }
    const columnDataMap = {
      createddate: 'created_At',
      bookingTime: 'booking_time',
      source: 'source',
      name: 'firstName',
      orderid: 'uniqueOrderId',
      totalStatus: 'orderTotal',
      ordertype: 'orderType',
      orderstatus: 'orderStatus',
    };

    const compareStrings = (a: string, b: string): number => {
      const lowerA = a?.toLowerCase();
      const lowerB = b?.toLowerCase();

      if (lowerA < lowerB) {
        return -1;
      } else if (lowerA > lowerB) {
        return 1;
      } else {
        return 0;
      }
    };

    return items.sort((a: OrderData, b: OrderData) => {
      let comparatorResult = 0;
      const key = columnDataMap[sort.active];
      switch (sort.active) {
        case 'createddate':
          const created_at_1 = moment(a.created_At);
          const created_at_2 = moment(b.created_At);
          comparatorResult = created_at_1.isBefore(created_at_2) ? 1 : -1;
          break;
        case 'bookingTime':
          const bt1 = a.booking_time;
          const bt2 = b.booking_time;
          if (!bt1 && !bt2) comparatorResult = 0;
          else if (!bt1) comparatorResult = 1;
          else if (!bt2) comparatorResult = -1;
          else comparatorResult = bt1.isBefore(bt2) ? 1 : -1;
          break;
        case 'orderid':
        case 'totalStatus':
          comparatorResult = a[key] - b[key];
          break;
        default:
          comparatorResult = compareStrings(a[key], b[key]);
          break;
      }
      return comparatorResult * (sort.direction == 'asc' ? 1 : -1);
    });
  }

  pageSizeChange(e: MatSelectChange) {
    this.pageSize = e.value;
    const filters = this.getCurrentFilters();
    this.getServerData(filters.status, filters.filter);
  }

  getFirstPage() {
    this.pageIndex = 1;
    const filters = this.getCurrentFilters();
    this.getServerData(filters.status, filters.filter);
  }

  getLastPage() {
    this.pageIndex = this.lastPage;
    const filters = this.getCurrentFilters();
    this.getServerData(filters.status, filters.filter);
  }

  getNextPage() {
    this.pageIndex++;
    const filters = this.getCurrentFilters();
    this.getServerData(filters.status, filters.filter);
  }

  getPreviousPage() {
    this.pageIndex--;
    const filters = this.getCurrentFilters();
    this.getServerData(filters.status, filters.filter);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    //.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /**
   * Filters the table based on the filter value provided
   *
   * @param   {string}  filterValue  The value of the filter
   *
   */
  selectFilter(filterValue: string) {
    if (this.filterBox == filterValue) {
      this.filterBox = '';
      this.dataSource.filter = '';
      this.to = this.dataSource.filteredData.length;
      const filters = this.getCurrentFilters();
      this.getServerData(filters.status, filters.filter);
    } else {
      this.pageIndex = 1;
      this.filterBox = filterValue;
      switch (filterValue) {
        case 'Returned Delivery':
          filterValue = 'Return';
          break;
        case 'Pending Returned Delivery':
          filterValue = 'Pending Return';
          break;
        default:
          break;
      }
      const filters = this.getCurrentFilters();
      this.getServerData(filters.status, filters.filter);
      this.dataSource.filter = filterValue;
    }
  }

  goToOrder(orderId: number, element?: OrderData) {
    if (this.jwtAuth.isClinician() && this.checkBookingTimeAndNotify(element, 'consultation')) {
      return;
    }

    if (this.jwtAuth.getIsDemoUserView() || (this.jwtAuth.isClinician() && this.status === OrdersTableStatus.Completed)) {
      this.navigateToOrderPage(orderId, element);
      return;
    }

    if (this.jwtAuth.isClinician() && ([OrderAssignStatusEnum.Assigned, OrderAssignStatusEnum.Paused].includes(element.order_assign_status))
      && !([OrderStatusEnum.Cancelled].includes(element.orderStatus))) {
      this.updateShiftStatus(element.shiftOrderId, () => {
        this.navigateToOrderPage(orderId, element);
      });
      return;
    }

    if (this.jwtAuth.isDriver()) {
      this.router.navigate(['driver/vieworders/', orderId]);
      return;
    }

    this.navigateToOrderPage(orderId, element);
  }

  checkBookingTimeAndNotify(element: OrderData, type?: 'consultation' | 'document_preview', customMessage?: string): boolean {
    const bookingTime = element?.booking_time;

    if (!(bookingTime instanceof moment) || !bookingTime.isValid()) {
      return false;
    }

    const currentTime = moment();
    const minutesUntilBooking = bookingTime.diff(currentTime, 'minutes');

    // Past appointments can be started without restrictions
    if (minutesUntilBooking < 0) {
      return false;
    }

    const earlyStartThreshold = this.getEarlyStartThresholdForOrder(element);

    const isAssigned = element.order_assign_status === OrderAssignStatusEnum.Assigned;

    if (minutesUntilBooking > earlyStartThreshold && isAssigned) {
      const notifyTime = moment(bookingTime).subtract(earlyStartThreshold, 'minutes').format('h:mm A');

      let message: string;

      // Use custom message if provided
      if (customMessage) {
        message = customMessage;
      } else {
        // Generate message based on type
        switch (type) {
          case 'document_preview':
            message = `Document preview not available yet — patient consultation scheduled at ${bookingTime.format('h:mm A')}. Preview available from ${notifyTime}`;
            break;
          case 'consultation':
          default:
            message = `Earliest consult can begin at ${notifyTime} — patient is scheduled later`;
            break;
        }
      }

      this.alertService.notifyInfo(message);
      return true;
    }

    return false;
  }


  getOrderAssignStatusText(element: OrderData): string {
    switch (element.order_assign_status) {
      case OrderAssignStatusEnum.Escalated:
        return element.escalatedNote || OrderAssignStatusEnum.Escalated;
      case OrderAssignStatusEnum.Assigned:
      case OrderAssignStatusEnum.Paused:

        if (element.consult_outcome) {
          let message = 'Consult Active';
          message += ` - ${element.consult_outcome}`;
          return message
        }

        return element.order_assign_status;
      case OrderAssignStatusEnum.Completed:
        let completedMessage = 'Consult Finished';
        const appendMessages: string[] = [];
        if (element.isScriptAdded === false) {
          appendMessages.push('Upload Script');
        } else if (element?.consult_outcome?.includes(ConsultOutcomeStatus.PAPER_SCRIPT)) {

          if (!element.isPaperScriptAdded) {
            appendMessages.push('Upload Paper Script');
          }

          if (!element?.paper_script_location) {
            appendMessages.push('Select Pharmacy');
          } else if (!element.paper_script_location_has_email) {
            appendMessages.push('Add Pharmacy Email');
          }

          if (!element.paper_script_email_sent) {
            appendMessages.push('Email Paper Script');
          }
        }

        if (appendMessages.length) {
          const last = appendMessages.pop();
          const joined = appendMessages.length
            ? appendMessages.join(', ') + ' and ' + last
            : last;
          completedMessage += ` - ${joined}`;
        }

        return completedMessage;
      default:
        return element.order_assign_status || OrderAssignStatusEnum.UnAssinged;
    }
  }

  navigateToOrderPage(orderId: number, element?: OrderData): void {
    let queryParams: Params = {};

    if (element?.status_code === OrderStatusCodeEnum.NoActiveItems) {
      queryParams.status = element.status_code;
    }

    this.router.navigate(
      [this.router.url, 'vieworders', orderId],
      { queryParams }
    );
  }

  getPaymentStatus(source: string, paymentStatus: PaymentStatusValue): string {
    try {
      // if (source?.endsWith('Follow-Up')) {
      //   return PAYMENT_STATUS_MAP[16];
      // }
      return PAYMENT_STATUS_MAP[paymentStatus] ?? 'Unknown';
    } catch (error) {
      return 'Unknown';
    }
  }

  openAddOwnerNoteDialog(event: Event, element: OrderData) {
    event.stopPropagation();
    this.dataOrder.openAddNoteDialog('owner', element.currentOwner || '', element.orderId, () => {
      const filters = this.getCurrentFilters();
      this.getServerData(filters.status, filters.filter);
    });
  }

  prepareSurveyData(stringifiedSurveyData: string): SurveyDataObj {
    try {
      return JSON.parse(stringifiedSurveyData).survey_data as SurveyDataObj;
    } catch (error) {
      return null;
    }
  }

  preparePatientName(surveyData: SurveyDataObj): string {
    const firstName = surveyData?.header?.user_data?.first_name || '';
    const lastName = surveyData?.header?.user_data?.last_name || '';
    return firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || null;
  }

  /**
   * Get the priority status of an order based on allocation group or booking type
   * @param element - The order data
   * @returns Object with priority information (isUrgent, isPriority, priorityText)
   */
  getOrderPriority(element: OrderData): { isUrgent: boolean; isPriority: boolean; priorityText: string } {
    const result = {
      isUrgent: false,
      isPriority: false,
      priorityText: ''
    };

    const bookingType = isSurveyDataObj(element.survey_data) ? element.survey_data?.header?.booking_type : null;

    // Check allocation group from API response
    if (element.group_id === AllocationGroup.PriorityEscalationOrder) {
      result.isUrgent = true;
      result.priorityText = 'URGENT REQUEST';
    } else if (element.group_id === AllocationGroup.PriorityOrder || bookingType === 'priority') {
      result.isPriority = true;
      result.priorityText = 'PRIORITY REQUEST';
    }

    return result;
  }

  prepareImportantSurveyData(element: OrderData): ImportantSurveyData[] {
    const result = [];
    const time = element.booking_time as Moment;

    if (isSurveyDataObj(element.survey_data)) {
      const survey_data = element.survey_data;
      const bookingType = survey_data?.header?.booking_type;
      const header = survey_data?.header;
      const priorityInfo = this.getOrderPriority(element);

      result.push(
        ...[
          {
            label: `<span class="mm-text-pink mm-fw-700"> ${priorityInfo.priorityText} </span>`,
            value: priorityInfo.isUrgent || priorityInfo.isPriority,
            bold: true,
          },
          {
            // Don't show booking type if we're showing priority (from allocation group or booking type)
            label: `<span class="mm-text-${TELEHEALTH_BOOKING_TYPE_COLORS[bookingType]}">${TELEHEALTH_BOOKING_TYPE[bookingType]}</span>`,
            value: Boolean(TELEHEALTH_BOOKING_TYPE[bookingType]) && !priorityInfo.isUrgent && !priorityInfo.isPriority,
          },
          {
            label: 'Issue Maximum Repeats',
            value: survey_data?.header?.has_repeats,
          },
          {
            label: `Patient Name: ${survey_data?.header?.user_data?.first_name} ${!this.jwtAuth.isClinician() ? survey_data?.header?.user_data?.last_name : survey_data?.header?.user_data?.last_name?.charAt(0) + '.'}`,
            value: Boolean(survey_data?.header?.user_data?.first_name),
          },
          {
            label: (() => {
              const isWeightLossRequest = survey_data?.header?.telehealth_type === TelehealthClassEnum.WEIGHT_LOSS;
              const isWeightLossFollowUp = isWeightLossRequest && Boolean(element.source?.includes('Subscription-Cycle'));
              if (isWeightLossFollowUp) {
                return `<span class="weight-loss-follow-up-badge">Weight Loss - Follow Up</span>`;
              }
              const text = `${TELEHEALTH_CLASS_MAP[survey_data?.header?.telehealth_type]
                }${survey_data?.header?.consult_type ? ` - ${survey_data.header.consult_type}` : ''
                }`;
              return `<span class="mm-text-orange">${text}</span>`;
            })(),
            value: Boolean(TELEHEALTH_CLASS_MAP[survey_data?.header?.telehealth_type]),
          },
          {
            label: survey_data?.header?.collection_method,
            value: Boolean(survey_data?.header?.collection_method),
          },
          {
            label: survey_data?.header?.user_data?.existing_patient
              ? 'Existing Patient'
              : 'New Patient',
            value: survey_data?.header?.user_data?.existing_patient
              ? 'Existing Patient'
              : 'New Patient',
          },
          {
            label: `<span class="mm-text-pink">INCOMPLETE INFORMATION</span>`,
            value: header?.information_complete === 0,
          },
        ]
      );
    }

    if (this.jwtAuth.isClinician()) {
      result.push({
        label: `<span class="mm-text-accent mm-fw-500">${Number(element.is_video_consult) === 1 ? 'Video Consult' : 'Phone Consult'}</span>`,
        value: true,
      });
    }

    if (time instanceof moment) {
      // Build booking time label
      let bookingLabel = `Booking Time <span class="mm-text-accent">${time.format('lll')}</span>`;

      // Add doctor name for Health Engine orders if requested_doctor_name exists
      if (element.source === 'Health-Engine' && isSurveyDataObj(element.survey_data)) {
        const doctorName = element.survey_data?.header?.requested_doctor_name;
        if (doctorName) {
          bookingLabel += ` for <span class="mm-text-accent mm-fw-700">${doctorName}</span>`;
        }
      }

      result.push({
        label: bookingLabel,
        value: time.isValid(),
      });
    }

    return result.filter(item => Boolean(item.value));
  }

  //TODO find better solution to unsubscribe to all panel subscriptions
  unsubscribeToOrderPanelSubscriptions() {
    this.orderPanelSubscriptions.forEach(subscription => subscription.unsubscribe());
    this.orderPanelSubscriptions = [];
  }

  clearSelection() {
    this.selection.clear();
    this.unsubscribeToOrderPanelSubscriptions();
  }

  openActionPanel() {
    const panelRef = this.orderPanelService.open();
    this.orderPanelSubscriptions.push(
      panelRef.on('close', () => {
        this.clearSelection();
      })
    );
    this.orderPanelSubscriptions.push(
      panelRef.on('changeStatus', () => {
        const filters = this.getCurrentFilters();
        this.getServerData(filters.status, filters.filter);
      })
    );

    this.orderPanelSubscriptions.push(
      panelRef.on('failed', () => {
        this.openAlert('Unable to add these orders to the queue. Please try again later.');
      })
    );

    this.orderPanelSubscriptions.push(
      panelRef.on('sendComms', () => {
        this.openAlert('Message sent successfully.', 'Dismiss', 'success');
      })
    );
  }

  toggleActionPanel() {
    if (this.selection.selected.length >= 1) {
      if (!this.orderPanelService.isOpen()) {
        this.openActionPanel();
      }
    } else {
      this.orderPanelService.closePanel();
    }
  }

  openAlert(msg: string, action = 'dismiss', type: 'success' | 'fail' = 'fail') {
    const snackBar = this._snackBar.openFromComponent(AlertSnackbarComponent, {
      panelClass: [type === 'fail' ? 'mat-bg-warn' : 'mm-bg-green'],
      data: { msg, action },
      verticalPosition: 'top',
      horizontalPosition: 'center',
      duration: 3000,
    });
    snackBar.afterDismissed().subscribe(() => {
      this.clearSelection();
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource?.data?.length;
    return numSelected === numRows;
  }

  openMaxSelectedRowsSnackBar() {
    this.openAlert(`You cannot select more than ${MAX_SELECTION_ALLOWED} rows.`);
  }

  maxSelectedRowsReached() {
    return this.selection.selected.length >= MAX_SELECTION_ALLOWED;
  }

  isRowDisabled(row: OrderData, index: number) {
    if (this.maxSelectedRowsReached() && !this.selection.isSelected(row)) {
      return true;
    }

    return false;
  }

  udpatePanelData() {
    this.orderPanelService.setOrders(this.selection.selected.map(order => order.orderId));
    const status = this.selection.selected[0]?.orderStatus as BulkActionStatus;
    this.orderPanelService.setFromStatus(status ?? null);
  }

  toggleRow(row: OrderData) {
    this.selection.toggle(row);
    this.udpatePanelData();
    this.toggleActionPanel();
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.clearSelection();
      this.toggleActionPanel();
      return;
    }

    if (this.dataSource?.data?.length > MAX_SELECTION_ALLOWED) {
      this.openMaxSelectedRowsSnackBar();
      this.selectAllTrigger.checked = false;
      return;
    }

    this.selection.select(...this.dataSource.data);
    this.udpatePanelData();
    this.toggleActionPanel();
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  formatNotes(noteType: NoteType, notes: string): string {
    return this.dataOrder.formatNotes(noteType, notes);
  }

  onQuickAction(orderDetails: OrderData, action: OrderActionType) {
    if (action === OrderActions.CheckDeliveryStatus) {
      this.loading = true;
      this.uberService.checkUberStatus(orderDetails.orderId).subscribe(
        res => {
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mat-bg-green'],
            data: {
              msg: res.message,
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 2000,
          });
          this.loading = false;
        },
        err => {
          this._snackBar.openFromComponent(AlertSnackbarComponent, {
            panelClass: ['mat-bg-warn'],
            data: {
              msg: 'Unable to find status',
              action: 'dismiss',
            },
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 2000,
          });
          this.loading = false;
        }
      );
    } else if (action === OrderActions.CreateFollowUpAppointment) {
      this.openCreateFollowUpRequestDialog(orderDetails.orderId);
    } else if (action === AdditionalActions.ChangeBatAppointment) {
      this.dataOrder.openManageAppointmentDialog(orderDetails.orderId, AdditionalActions.ChangeBatAppointment, () => this.getServerData());
      return;
    } else if (action === AdditionalActions.ChangeNaToBat) {
      this.dataOrder.openManageAppointmentDialog(orderDetails.orderId, AdditionalActions.ChangeNaToBat, () => this.getServerData());
      return;
    } else if (action === OrderActions.MoveToUrgent) {
      this.confirmMoveToUrgent(orderDetails.orderId, orderDetails.orderStatus);
      return;
    } else if (action === AdditionalActions.SendManualReminder) {
      this.confirmSendManualReminder(orderDetails.orderId);
      return;
    } else if (action === AdditionalActions.Dispense) {
      this.dataOrder.dispenseTelehealthOrder(this.getTrackingLinkOrder(orderDetails), () => this.refreshWithCurrentFilters());
      return;
    } else if (action === AdditionalActions.AddTrackingLink) {
      this.dataOrder.addTrackingLinkAndComplete(this.getTrackingLinkOrder(orderDetails), () => this.refreshWithCurrentFilters());
      return;
    }
    else if (action !== 'Change Pharmacy') {
      if (action === 'Reject') {
        if (this.dataOrder.isConsultActive(orderDetails.order_assign_status)) {
          this.dataOrder.showConsultActiveDialog('cancel');
          return;
        }
        action = 'Rejected';
        this.confirmCancelOrder(
          orderDetails.orderId,
          orderDetails?.orderPaidAmount,
          orderDetails.orderStatus,
          action,
          true
        );
        return;
      } else if ((action === 'Cancel' || action === 'Cancelled') && this.admin == '0') {
        if (this.dataOrder.isConsultActive(orderDetails.order_assign_status)) {
          this.dataOrder.showConsultActiveDialog('cancel');
          return;
        }
        // If already Pending Cancellation, go directly to cancel dialog
        const isHEOrder = !!orderDetails.source?.includes(SourceEnum.HEALTH_ENGINE);
        if (orderDetails.orderStatus === OrderStatusEnum.PendingCancellation) {
          this.confirmCancelOrder(
            orderDetails.orderId,
            orderDetails?.orderPaidAmount,
            orderDetails.orderStatus,
            OrderStatusEnum.Cancelled,
            false,
            isHEOrder
          );
          return;
        }
        action = 'Pending Cancellation';
        this.confirmCancelOrder(
          orderDetails.orderId,
          orderDetails?.orderPaidAmount,
          orderDetails.orderStatus,
          action,
          false,
          isHEOrder
        );
        return;
      } else if (action === 'Cancel' || action === 'Cancelled') {
        if (this.dataOrder.isConsultActive(orderDetails.order_assign_status)) {
          this.dataOrder.showConsultActiveDialog('cancel');
          return;
        }
        // If already Pending Cancellation, go directly to cancel dialog
        const isHEOrder = !!orderDetails.source?.includes(SourceEnum.HEALTH_ENGINE);
        if (orderDetails.orderStatus === OrderStatusEnum.PendingCancellation) {
          this.confirmCancelOrder(
            orderDetails.orderId,
            orderDetails?.orderPaidAmount,
            orderDetails.orderStatus,
            OrderStatusEnum.Cancelled,
            false,
            isHEOrder
          );
          return;
        }
        action = 'Cancelled';
        this.confirmCancelOrder(
          orderDetails.orderId,
          orderDetails?.orderPaidAmount,
          orderDetails.orderStatus,
          action,
          false,
          isHEOrder
        );
        return;
      } else if (['In Transit', 'Return', 'Completed'].includes(action)) {
        if (action === OrderStatusEnum.Completed && this.dataOrder.isConsultActive(orderDetails.order_assign_status)) {
          this.dataOrder.showConsultActiveDialog('complete');
          return;
        }
        this.openConfirmationDialog(orderDetails.orderId, orderDetails.orderStatus, action);
        return;
      } else if (action === 'Accept') {
        orderDetails.paymentStatus == '1'
          ? (action = 'Process')
          : orderDetails.orderType == 'Pick Up' || orderDetails.orderType == 'Pickup'
            ? (action = 'Process')
            : (action = 'Waiting For Review');
      } else if (action === OrderActions.Cancelled) {
        if (this.dataOrder.isConsultActive(orderDetails.order_assign_status)) {
          this.dataOrder.showConsultActiveDialog('cancel');
          return;
        }
      }

      if ((orderDetails.orderStatus === OrderStatusEnum.Completed || orderDetails.orderStatus === OrderStatusEnum.Cancelled) &&
        action === OrderStatusEnum.ClinicToAction &&
        this.dataOrder.shouldCaptureWaitingRoomReason(orderDetails.order_assign_status)) {
        this.loading = true;
        this.dataOrder.showWaitingRoomReasonDialog(
          orderDetails.orderId,
          orderDetails.orderStatus,
          action,
          () => {
            this.loading = false;
            this.getServerData();
          },
          () => {
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
        return;
      }

      this.loading = true;
      this.dataOrder
        ._changeOrderStatus(orderDetails.orderId, orderDetails.orderStatus, action, '')
        .subscribe(
          res => {
            this._snackBar.openFromComponent(AlertSnackbarComponent, {
              panelClass: ['mm-bg-green'],
              data: {
                msg: 'Status changed successfully',
                action: 'dismiss',
              },
              duration: 2400,
            });
            this.loading = false;
            const filters = this.getCurrentFilters();
            this.getServerData(filters.status, filters.filter);
          },
          error => {
            this._snackBar.openFromComponent(AlertSnackbarComponent, {
              panelClass: ['mm-bg-pink'],
              data: {
                msg: error.error['msg'],
                action: 'dismiss',
              },
              duration: 2400,
            });
            this.loading = false;
          }
        );
    } else {
      this.router.navigate([
        'orders/changepharmacy/',
        orderDetails.locationId,
        orderDetails.postcode,
        orderDetails.orderId,
      ]);
    }
  }

  private getTrackingLinkOrder(orderDetails: OrderData): TrackingLinkOrder {
    return { orderId: orderDetails.orderId, userId: orderDetails.enduserid, isPickup: isPickupOrderType(orderDetails.orderType) };
  }

  private refreshWithCurrentFilters() {
    const filters = this.getCurrentFilters();
    this.getServerData(filters.status, filters.filter);
  }

  previewOrderDocument(element) {
    // Check if clinician is trying to view document before appointment early threshold time
    if (this.jwtAuth.isClinician() && this.checkBookingTimeAndNotify(element, 'document_preview')) {
      return; // Don't open the dialog if before threshold time
    }

    const dialogRef = this.dialog.open(DialogPreviewDocumentComponent, {
      data: {
        orderId: element.orderId,
        userId: element.enduserid
      },
      minWidth: '70%',
    });
    dialogRef.afterClosed().subscribe(result => {
      this.dialog.closeAll();
    })
  }

  canShowEscalateButton(element: OrderData): boolean {
    return this.jwtAuth.isClinician() && element.shiftOrderId &&
      element.order_assign_status !== OrderAssignStatusEnum.Escalated &&
      element.order_assign_status !== OrderAssignStatusEnum.Completed;
  }

  escalateOrder(element: OrderData) {
    const dialogRef = this.dialog.open(DialogOutOfScopeComponent, {
      width: '400px',
      data: {
        title: 'Provide Reason for Escalation',
        options: [
          {
            firstOption: ['Out of Scope'],
            enableTextArea: true
          },
          {
            firstOption: ['Called not answered'],
          },
          {
            firstOption: ['Restricted Medication'],
            textAreaPlaceholder: 'Restricted Medication',
            enableTextArea: true
          },
        ]
      }
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.updateOrderShiftStatus(element, OrderAssignStatusEnum.Escalated, data);
      }
    });
  }

  updateOrderShiftStatus(element: OrderData, status: OrderAssignStatusEnum, escalationReason?: EscalationReason) {
    const data = {
      shiftOrderId: element.shiftOrderId,
      status: status,
      ...escalationReason
    };

    this.dataOrder.updateClinicianShiftOrderStatus(data).subscribe(
      res => {
        this.alertService.notifySuccess(res.msg || 'Order escalated successfully');
        this.getServerData();
      },
      err => {
        this.alertService.notifyError(err.error?.msg || 'Failed to escalate order');
      }
    );
  }

  openAddClinicianNoteDialog(event: Event, element: OrderData) {
    event.stopPropagation();
    this.dataOrder.openAddNoteDialog('clinician', element.clinician_notes || '', element.orderId, () => {
      const filters = this.getCurrentFilters();
      this.getServerData(filters.status, filters.filter);
    });
  }

  confirmCancelOrder(
    orderId: number,
    orderTotal: string,
    currentStatus: string,
    toStatus: string,
    isRejectOrder: boolean = false,
    useRefundFlag: boolean = false
  ) {
    const dialogRef = this.dialog.open(DialogCancelOrderComponent, {
      data: {
        refundAmount: orderTotal,
        orderid: orderId,
        currentStatus,
        toStatus,
        isRejectOrder,
        headerText: isRejectOrder ? 'Reject Order' : null,
        useRefundFlag,
      },
      width: '400px',
      maxWidth: '400px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.dialog.closeAll();
      }
    });
  }

  confirmSendManualReminder(orderId: number): void {
    this.loading = true;
    this.dataOrder.confirmSendManualReminder(
      orderId,
      () => {
        this.loading = false;
        const filters = this.getCurrentFilters();
        this.getServerData(filters.status, filters.filter);
      },
      () => {
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  openConfirmationDialog(orderId: number, currentStatus: string, toStatus: string): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '350px',
      data: {
        headerText: `Change Order Status to ${toStatus}?`,
        message: "Are you sure? Once changed, you can't undo.",
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        if (toStatus === OrderStatusEnum.Completed) {
          const orderData = this.dataSource.data.find(order => order.orderId === orderId);
          if (orderData && this.dataOrder.isConsultActive(orderData.order_assign_status)) {
            this.dataOrder.showConsultActiveDialog('complete');
            return;
          }
        }
        this.loading = true;
        this.dataOrder._changeOrderStatus(orderId, currentStatus, toStatus, '').subscribe(
          res => {
            this._snackBar.openFromComponent(AlertSnackbarComponent, {
              panelClass: ['mm-bg-green'],
              data: {
                msg: res.msg,
                action: 'dismiss',
              },
              duration: 2400,
            });
            this.loading = false;
            window.location.reload();
          },
          err => {
            this._snackBar.openFromComponent(AlertSnackbarComponent, {
              panelClass: ['mm-bg-warn'],
              data: {
                msg: err.error.msg,
                action: 'dismiss',
              },
              duration: 2400,
            });
            this.loading = false;
          }
        );
      } else {
        return;
      }
    });
  }

  confirmMoveToUrgent(orderId: number, currentStatus: string): void {
    this.loading = true;
    this.dataOrder.moveOrderToUrgent(
      orderId,
      currentStatus,
      () => {
        // Success callback
        this.loading = false;
        const filters = this.getCurrentFilters();
        this.getServerData(filters.status, filters.filter);
      },
      (error) => {
        // Error callback
        this.loading = false;
      },
      () => {
        // Cancel callback
        this.loading = false;
      }
    );
  }

  openGoogleMaps(lat: number, lng: number) {
    const url = this.getGoogleMapsUrl(lat, lng);
    window.open(url, '_system');
  }

  private getGoogleMapsUrl(latitude: number, longitude: number): string {
    const baseUrl = 'https://www.google.com/maps/dir/?api=1';

    return `${baseUrl}&destination=${latitude},${longitude}&travelmode=driving`;
  }

  unescapeNewlineChars(text: string): string {
    return unescapeNewlineChars(text);
  }

  getOrderStatusCodes(): Observable<void> {
    // Get the user's role to filter status codes
    return this.jwtAuth.getUserRole().pipe(
      switchMap((userRole) => {
        if (userRole?.profiletypeid) {
          return this.systemSettingsService.getRoleBasedStatusCodes(userRole.profiletypeid);
        } else {
          return of({} as OrderStatusCodes);
        }
      }),
      tap((filteredStatusCodes) => {
        this.orderStatusCodes = filteredStatusCodes as OrderStatusCodes;
      }),
      switchMap(() => of(undefined)),
      catchError((error) => {
        this.orderStatusCodes = {} as OrderStatusCodes;
        return of(undefined);
      })
    );
  }

  getEarlyStartThreshold() {
    this.systemSettingsService.getSystemSettings({ categoryid: config.systemSettingCategoryIds.earlyStartThreshold }).subscribe((settings) => {
      this.consultWaitTime = settings;
    });
  }

  openCreateFollowUpRequestDialog(orderId: number) {
    this.dialog.open(DialogCreateFollowUpRequestComponent, {
      width: '90%',
      maxWidth: '1300px',
      data: {
        orderId: orderId,
        action: AdditionalActions.CreateFollowUpAppointment
      },
    });
  }

  shouldShowUnassignOption(element: OrderData): boolean {
    return element.order_assign_status === OrderAssignStatusEnum.Assigned && Boolean(element.selectedClinician?.id);
  }

  isOrderAssignStatusChipVisibleForUser(): boolean {
    return (
      !this.jwtAuth.isClinician() &&
      [
        OrdersTableStatus.ClinicToAction,
        OrdersTableStatus.ClinicToReview,
        OrdersTableStatus.ClinicToUpdate,
        OrdersTableStatus.WaitingRoom,
        OrdersTableStatus.WaitingForInformation,
        OrdersTableStatus.RequestIssued,
        OrdersTableStatus.TelehealthPending,
        OrdersTableStatus.TelehealthRequestIssued,
        OrdersTableStatus.ClinicToActionAdmin,
        OrdersTableStatus.CareCall
      ].includes(this.status)
    );
  }

  get shouldShowDateFilter(): boolean {
    // Show date filter for clinicians only in Completed view
    if (this.jwtAuth.isClinician()) {
      return this.status === OrdersTableStatus.Completed;
    }
    return true;
  }

  canShowFilters() {
    // Show filters for clinicians only in Completed view (consult status filter)
    if (this.jwtAuth.isClinician()) {
      // Show filters if there are visible (non-hidden) filters
      if (this.filtersConfig && this.filtersConfig.length > 0) {
        return this.filtersConfig.some(filter => !filter.hidden);
      }
      return false;
    }
    // An empty config is truthy as an array, so test length: screens with no
    // filters must keep the panel hidden, as they were when the lookup
    // returned undefined.
    return (
      this.jwtAuth.isAdmin() ||
      this.jwtAuth.isBusiness() ||
      this.jwtAuth.isPharmacyUser()
    ) && !!this.filtersConfig?.length;
  }

  loadFilters() {
    this.dataOrder.getFilters(this.jwtAuth.getUser().role as ProfileType, this.status).subscribe(
      response => {
        this.filtersConfig = response;
        this.initializeFilterForm();

        // Load data after filters are initialized
        if (!this.isLoadingOrders) {
          const filters = this.getCurrentFilters();
          this.getServerData(filters.status, filters.filter);
        }
      },
      error => {
        console.error('Error loading filters:', error);
        this.filtersConfig = [];

        // Load data even if filters fail
        if (!this.isLoadingOrders) {
          const filters = this.getCurrentFilters();
          this.getServerData(filters.status, filters.filter);
        }
      }
    );
  }

  initializeFilterForm() {
    // Get current URL params
    const urlParams = this.route.snapshot.queryParams;
    let hasUrlFilters = false;

    this.filtersConfig?.forEach(filter => {
      // Check if filter value exists in URL, otherwise use default
      let initialValue = filter.default ?? (filter.multi ? [] : '');

      if (urlParams[filter.key] !== undefined) {
        hasUrlFilters = true;
        // Parse URL param value based on filter type
        if (filter.multi) {
          // Check if value is 'all' - if so, select all options
          if (urlParams[filter.key] === 'all' && filter.options) {
            initialValue = filter.options.map(opt => opt.value);
          } else {
            // For multi-select, parse JSON array
            try {
              initialValue = JSON.parse(urlParams[filter.key]);
            } catch (e) {
              // Fallback to splitting by comma
              initialValue = urlParams[filter.key].split(',').filter(v => v);
            }
          }
        } else {
          // For single-select, parse as string or extract first element from array
          try {
            const parsed = JSON.parse(urlParams[filter.key]);
            initialValue = Array.isArray(parsed) ? parsed[0] : parsed;
          } catch (e) {
            initialValue = urlParams[filter.key];
          }
        }
      } else if (!filter.multi && Array.isArray(initialValue) && initialValue.length > 0) {
        // For single-select with array default, extract first element for FormControl
        initialValue = initialValue[0];
      }

      this.filterForm.addControl(filter.key, new UntypedFormControl(initialValue));
    });

    // Don't apply filters from URL here - let ngAfterViewInit handle initial load
    // This prevents duplicate API calls
  }

  /**
   * Helper: Normalize value to array
   */
  private normalizeToArray(value: any): any[] {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [value];
  }

  /**
   * Helper: Get default value for filter (extracts first element for single-select)
   */
  private getFilterDefaultValue(filter: any): any {
    if (filter.default === undefined || filter.default === null) {
      return filter.multi ? [] : null;
    }
    // For single-select with array default, extract first element
    if (!filter.multi && Array.isArray(filter.default) && filter.default.length > 0) {
      return filter.default[0];
    }
    return filter.default;
  }

  /**
   * Helper: Check if all options are selected for a multi-select filter
   */
  private isAllOptionsSelectedInFilter(filter: any, selectedValues: any[]): boolean {
    if (!filter.multi || !filter.options || selectedValues.length === 0) return false;
    const allOptionValues = filter.options.map(opt => opt.value);
    return selectedValues.length === allOptionValues.length &&
      allOptionValues.every(val => selectedValues.includes(val));
  }

  /**
   * Expand filter values to include all aliases
   */
  private expandFilterAliases(formValue: any): any {
    const expandedValue = { ...formValue };

    this.filtersConfig?.forEach(filter => {
      // Skip orderStatus - it's sent as status parameter, not in filter
      if (filter.key === 'orderStatus') {
        return;
      }

      // For hidden filters, always include their default value if not already present
      if (filter.hidden && (expandedValue[filter.key] === undefined || expandedValue[filter.key] === null)) {
        const defaultValue = this.getFilterDefaultValue(filter);
        if (defaultValue !== null && defaultValue !== undefined) {
          expandedValue[filter.key] = this.normalizeToArray(defaultValue);
          return;
        }
      }

      if (expandedValue[filter.key] === undefined || expandedValue[filter.key] === null) {
        return;
      }

      const selectedValues = this.normalizeToArray(expandedValue[filter.key]);

      // Remove filter if all options are selected (except orderStatus and hidden filters)
      if (filter.key !== 'orderStatus' && !filter.hidden && this.isAllOptionsSelectedInFilter(filter, selectedValues)) {
        delete expandedValue[filter.key];
        return;
      }

      // Expand aliases if configured
      if (filter.aliases) {
        const expandedValues = new Set<string>();
        selectedValues.forEach(value => {
          if (filter.aliases[value]) {
            filter.aliases[value].forEach(alias => expandedValues.add(alias));
          } else {
            expandedValues.add(value);
          }
        });
        expandedValue[filter.key] = Array.from(expandedValues);
      } else {
        expandedValue[filter.key] = selectedValues;
      }
    });

    return expandedValue;
  }

  /**
   * Helper: Clean filter values (remove 'select-all' and empty arrays)
   */
  private cleanFilterValues(formValue: any): any {
    const cleaned = { ...formValue };
    Object.keys(cleaned).forEach(key => {
      if (Array.isArray(cleaned[key])) {
        cleaned[key] = cleaned[key].filter(v => v !== 'select-all');
        if (cleaned[key].length === 0) {
          delete cleaned[key];
        }
      }
    });
    return cleaned;
  }

  applyFilters() {
    console.log(this.filterForm.value);

    // Validate date range if date filter should be shown
    if (this.shouldShowDateFilter) {
      const start: Moment = this.range.get('start').value;
      const end: Moment = this.range.get('end').value;

      if ((start && !end) || (!start && end)) {
        this.alertService.notifyError('Please select both start date and end date');
        return;
      }
    }

    // Clean and separate orderStatus from other filters
    const cleanedValue = this.cleanFilterValues(this.filterForm.value);
    const orderStatusArray = this.normalizeToArray(cleanedValue.orderStatus);
    delete cleanedValue.orderStatus;

    // Check if no order status is selected
    if (orderStatusArray.length === 0) {
      this.alertService.notifyError('Please select at least one order status');
      return;
    }

    // Expand aliases and clean again
    const expandedValue = this.cleanFilterValues(this.expandFilterAliases(cleanedValue));

    // Update URL and fetch data  
    this.updateUrlParams();
    const statusParam = orderStatusArray.join(',');
    const filterParam = Object.keys(expandedValue).length > 0 ? JSON.stringify(expandedValue) : '';
    this.getServerData(statusParam, filterParam);
  }

  /**
   * Toggle select all options for a multi-select filter
   */
  toggleSelectAll(filter: any): void {
    const control = this.filterForm.controls[filter.key];

    if (this.isAllOptionsSelected(filter)) {
      // Deselect all
      control.setValue([]);
    } else {
      // Select all
      const allValues = filter.options.map(opt => opt.value);
      control.setValue(allValues);
    }
  }

  /**
   * Get display text for selected filter values
   */
  getSelectedFilterText(filter: any): string {
    const control = this.filterForm.controls[filter.key];
    const selectedValues = control?.value || [];

    if (selectedValues.length === 0) {
      return filter.label;
    } else if (selectedValues.length === filter.options.length && filter.options.length > 1) {
      return 'All selected';
    } else if (selectedValues.length === 1) {
      const selectedOption = filter.options.find(opt => opt.value === selectedValues[0]);
      if (filter.key === 'orderStatus' && selectedOption) {
        return this.getOrderStatusLabel(selectedOption.value);
      }
      return selectedOption?.label || selectedValues[0];
    } else {
      return `${selectedValues.length} selected`;
    }
  }

  /**
   * Check if all options are selected for a multi-select filter
   */
  isAllOptionsSelected(filter: any): boolean {
    const control = this.filterForm.controls[filter.key];
    const currentValue = control?.value || [];
    return currentValue.length === filter.options.length;
  }

  /**
   * Check if there are any visible filters
   */
  hasVisibleFilters(): boolean {
    if (!this.filtersConfig || this.filtersConfig.length === 0) {
      return false;
    }
    return this.filtersConfig.some(filter => !this.shouldHideFilter(filter));
  }

  /**
   * Get count of active filters (including date filter)
   */
  getActiveFiltersCount(): number {
    let count = 0;

    // Include search
    if (this.searchControl.value) {
      count++;
    }

    // Include date filter
    if (this.isDateFilterActive()) {
      count++;
    }

    if (!this.filtersConfig?.length) return count;

    count += this.filtersConfig.filter(filter => {
      if (filter.key === 'orderStatus') {
        return this.isOrderStatusFilterActive(filter);
      }
      if (this.shouldHideFilter(filter)) {
        return false;
      }
      return this.isFilterActive(filter);
    }).length;

    return count;
  }

  /**
   * Check if a specific filter is active (different from default)
   */
  isFilterActive(filter: any): boolean {
    if (!filter) return false;

    const control = this.filterForm.controls[filter.key];
    if (!control) return false;

    const currentValue = control.value;
    const defaultValue = this.getFilterDefaultValue(filter);

    if (filter.multi) {
      const currentArray = this.normalizeToArray(currentValue);
      const defaultArray = this.normalizeToArray(defaultValue);
      if (currentArray.length !== defaultArray.length) return true;
      return !currentArray.every(val => defaultArray.includes(val));
    }

    return currentValue !== defaultValue;
  }

  /**
   * Clear a single filter (reset to default)
   */
  clearSingleFilter(filter: any): void {
    if (!filter) return;

    const control = this.filterForm.controls[filter.key];
    if (!control) return;

    const defaultValue = this.getFilterDefaultValue(filter);
    control.setValue(defaultValue);

    // Auto-apply after clearing
    this.applyFilters();
  }

  /**
   * Helper: Check if orderStatus filter is active
   */
  private isOrderStatusFilterActive(filter: any): boolean {
    const control = this.filterForm.controls[filter.key];
    if (!control) return false;

    const currentArray = this.normalizeToArray(control.value);
    const defaultArray = this.normalizeToArray(filter.default);
    return currentArray.length < defaultArray.length;
  }

  /**
   * Helper: Check if date filter is active (different from default)
   */
  private isDateFilterActive(): boolean {
    // Check if either date is set
    const start = this.range.get('start').value;
    const end = this.range.get('end').value;
    return !!(start || end);
  }

  /**
   * Check if any filters have values different from defaults (including date filter)
   */
  hasActiveFilters(): boolean {
    // Check search
    if (this.searchControl.value) {
      return true;
    }

    // Check date filter
    if (this.isDateFilterActive()) {
      return true;
    }

    if (!this.filtersConfig?.length) return false;

    return this.filtersConfig.some(filter => {
      if (filter.key === 'orderStatus') {
        return this.isOrderStatusFilterActive(filter);
      }
      if (this.shouldHideFilter(filter)) {
        return false;
      }
      return this.isFilterActive(filter);
    });
  }

  /**
   * Clear all filters (reset to defaults including orderStatus)
   */
  clearAllFilters(): void {
    if (!this.filtersConfig) return;

    // Clear search
    this.searchControl.setValue('');

    this.filtersConfig.forEach(filter => {
      const control = this.filterForm.controls[filter.key];
      if (control) {
        control.setValue(this.getFilterDefaultValue(filter));
      }
    });

    // Reset date filter
    this.clearDateFilter();
  }

  /**
   * Clear date filter
   */
  clearDateFilter(): void {
    // Reset the date range form controls
    this.range.reset();
    this.startDate = null;
    this.endDate = null;
    this.updateUrlParams();
    this.applyFilters();
  }

  /**
   * Clear search input
   */
  clearSearch(): void {
    this.searchControl.setValue('');
  }

  /**
   * Export appointments to CSV
   */
  exportAppointments(): void {
    if (!this.dataSource?.data?.length) {
      this.alertService.notifyInfo('No appointments to export');
      return;
    }

    const appointments = this.dataSource.data;
    
    const csvData = appointments.map((order: OrderData) => ({
      'Order ID': order.uniqueOrderId || order.orderId,
      'Created Date': order.created_At || '',
      'Booking Time': order.booking_time ? order.booking_time.format('DD/MM/YYYY h:mm A') : '',
      'Patient Name': order.patientName || `${order.firstName || ''} ${order.lastName || ''}`.trim(),
      'Patient Mobile': order.mobile || '',
      'Source': order.source || '',
      'Location': order.locationname || '',
      'Order Status': order.orderStatus || '',
      'Consult Status': order.order_assign_status || '',
      'Clinician': order.selectedClinician?.name || '',
      'Order Class': order.order_class || '',
      'Booking Type': order.survey_data?.header?.booking_type || '',
      'Important': order.importantSurveyData?.map(i => i.label).join(', ') || '',
    }));

    const csvContent = this.convertToCSV(csvData);
    const dateStr = moment().format('DD-MM-YYYY');
    const filename = `appointments_export_${dateStr}.csv`;
    this.downloadCSV(csvContent, filename);
    this.alertService.notifySuccess('Appointments exported successfully');
  }

  /**
   * Export active orders to CSV
   */
  exportActiveOrders(): void {
    if (!this.dataSource?.data?.length) {
      this.alertService.notifyInfo('No orders to export');
      return;
    }

    const orders = this.dataSource.data;

    const csvData = orders.map((order: OrderData) => ({
      'Order ID': order.uniqueOrderId || order.orderId,
      'Received Date': order.created_At || '',
      'Booking Time': order.booking_time ? order.booking_time.format('DD/MM/YYYY h:mm A') : '',
      'Source': order.source || '',
      'Customer Name': order.patientName || `${order.firstName || ''} ${order.lastName || ''}`.trim(),
      'Total': order.orderTotal || '',
      'Type': this.getdeliveryType(order.orderType, order.deliveryPartnerName) || '',
      'Order Status': this.getOrderStatusLabel(order.orderStatus) || '',
      'Owner': order.currentOwner || '',
      'External Reference': order.external_reference_id || '',
    }));

    const csvContent = this.convertToCSV(csvData);
    const dateStr = moment().format('DD-MM-YYYY');
    const filename = `active_orders_export_${dateStr}.csv`;
    this.downloadCSV(csvContent, filename);
    this.alertService.notifySuccess('Orders exported successfully');
  }

  /**
   * Convert array of objects to CSV string
   */
  private convertToCSV(data: any[]): string {
    if (data.length === 0) return '';

    const headers = Object.keys(data[0]);
    const rows = data.map(row => 
      headers.map(header => `"${(row[header] || '').toString().replace(/"/g, '""')}"`).join(',')
    );

    return [headers.join(','), ...rows].join('\n');
  }

  /**
   * Download CSV file
   */
  private downloadCSV(csvContent: string, filename: string): void {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }

  filterOptions(filterKey: string): void {
    const filter = this.filtersConfig.find(f => f.key === filterKey);
    if (!filter || !filter.options) return;

    const searchText = (this.filterSearchText.get(filterKey) || '').toLowerCase().trim();
    if (!searchText) {
      this.filteredOptionsMap.delete(filterKey);
      return;
    }

    const filtered = filter.options.filter(option => {
      // Search in label
      if (option.label.toLowerCase().includes(searchText)) {
        return true;
      }
      // Search in searchText field if available (for location ID search)
      if (option.searchText && option.searchText.toLowerCase().includes(searchText)) {
        return true;
      }
      return false;
    });
    this.filteredOptionsMap.set(filterKey, filtered);
  }

  getFilteredOptions(filter: any): any[] {
    const rawValue = this.filterForm.controls[filter.key]?.value;
    const selectedValues: any[] = Array.isArray(rawValue) ? rawValue : (rawValue != null && rawValue !== '' ? [rawValue] : []);

    if (this.filteredOptionsMap.has(filter.key)) {
      const filteredOptions = this.filteredOptionsMap.get(filter.key);

      // Include selected options even if they don't match the search
      const selectedOptions = filter.options.filter(opt =>
        selectedValues.includes(opt.value) &&
        !filteredOptions.some(filtered => filtered.value === opt.value)
      );

      return [...selectedOptions, ...filteredOptions];
    }

    // When no search text, show selected items at the top
    const allOptions = filter.options || [];
    if (this.shouldShowFilterSearch(filter) && selectedValues.length > 0) {
      const selected = allOptions.filter(opt => selectedValues.includes(opt.value));
      const unselected = allOptions.filter(opt => !selectedValues.includes(opt.value));
      return [...selected, ...unselected];
    }

    return allOptions;
  }

  shouldShowFilterSearch(filter: any): boolean {
    return filter.options && filter.options.length > this.FILTER_SEARCH_THRESHOLD;
  }

  getFilterSearchText(filterKey: string): string {
    return this.filterSearchText.get(filterKey) || '';
  }

  setFilterSearchText(filterKey: string, value: string): void {
    this.filterSearchText.set(filterKey, value);
    this.filterOptions(filterKey);
  }

  clearFilterSearch(filterKey: string): void {
    this.filterSearchText.delete(filterKey);
    this.filteredOptionsMap.delete(filterKey);
  }

  /**
   * Check if filter should be hidden (only one option and matches default, or explicitly marked as hidden)
   */
  shouldHideFilter(filter: any): boolean {
    // Check if filter is explicitly marked as hidden
    if (filter.hidden === true) {
      return true;
    }

    if (!filter.options || filter.options.length !== 1) {
      return false;
    }

    const control = this.filterForm.controls[filter.key];
    const currentValue = control?.value;
    const defaultValue = filter.default;

    // For multi-select (arrays)
    if (filter.multi) {
      const currentArray = Array.isArray(currentValue) ? currentValue : [];
      const defaultArray = Array.isArray(defaultValue) ? defaultValue : [];

      // Hide if both are empty arrays or both have same single value
      if (currentArray.length === 0 && defaultArray.length === 0) {
        return true;
      }
      if (currentArray.length === 1 && defaultArray.length === 1 && currentArray[0] === defaultArray[0]) {
        return true;
      }

      return false;
    }

    // For single-select
    return currentValue === defaultValue;
  }

  /**
   * Apply filters from URL without updating URL again (used on page load)
   */
  private applyFiltersFromUrl() {
    const formValue = { ...this.filterForm.value };
    // Remove 'select-all' from arrays
    Object.keys(formValue).forEach(key => {
      if (Array.isArray(formValue[key])) {
        formValue[key] = formValue[key].filter(v => v !== 'select-all');
      }
    });

    const orderStatusArray = formValue.orderStatus || [];

    // Remove orderStatus from the filter object
    delete formValue.orderStatus;

    // Send orderStatus as status parameter, rest as filter JSON
    // Use filter config as single source of truth - send what's in the form, don't fallback to statuses config
    const statusParam = orderStatusArray.length > 0 ? orderStatusArray.join(',') : '';
    this.getServerData(statusParam, JSON.stringify(formValue));
  }

  /**
   * Get current filter state for API calls (used by pagination)
   */
  private getCurrentFilters(): { status: string; filter: string } {
    if (!this.filterForm || !this.filterForm.value) {
      return {
        status: this.filterBox !== '' ? this.filterBox : this.statuses[this.status].status,
        filter: ''
      };
    }

    const cleanedValue = this.cleanFilterValues(this.filterForm.value);
    const orderStatusArray = this.normalizeToArray(cleanedValue.orderStatus);
    delete cleanedValue.orderStatus;

    const expandedValue = this.cleanFilterValues(this.expandFilterAliases(cleanedValue));
    const statusParam = orderStatusArray.length > 0 ?
      orderStatusArray.join(',') :
      this.statuses[this.status].status;
    const filterParam = Object.keys(expandedValue).length > 0 ? JSON.stringify(expandedValue) : '';

    return { status: statusParam, filter: filterParam };
  }

  getOrderStatusLabel(orderStatus: OrderStatus, hasPendingDataForm?: boolean): string {
    return this.dataOrder.getOrderStatusLabel(orderStatus, hasPendingDataForm);
  }

  /**
   * Get display label for filter option (uses special handling for orderStatus)
   */
  getFilterOptionLabel(filter: any, option: any): string {
    if (filter.key === 'orderStatus') {
      return this.getOrderStatusLabel(option.value);
    }
    return option.label;
  }

  /**
   * Format BAT appointments to show order ID and time
   */
  getBatAppointmentsTooltip(batAppointments: any[]): string {
    if (!batAppointments || batAppointments.length === 0) {
      return 'No BAT appointments';
    }

    const appointments = batAppointments.map(apt => {
      // Each appointment is an object like { "72114": "2025-07-18T07:50:00+00:00" }
      const orderId = Object.keys(apt)[0];
      const datetime = apt[orderId];

      // Format datetime using moment
      const formatted = moment(datetime).format('DD MMM YYYY, hh:mm A');

      return `Order #${orderId}: ${formatted}`;
    });

    return appointments.join('\n');
  }

  /**
   * Update URL query params with current date filter state and all other filters
   */
  private updateUrlParams(): void {
    const queryParams: Params = {};

    // Add dates to URL params if they are set
    if (this.startDate && this.endDate) {
      queryParams.startDate = this.startDate;
      queryParams.endDate = this.endDate;
    }

    // Add all filter form values to URL params
    if (this.filterForm && this.filterForm.value) {
      Object.keys(this.filterForm.value).forEach(key => {
        const value = this.filterForm.value[key];
        const filter = this.filtersConfig.find(f => f.key === key);

        if (value !== null && value !== undefined && value !== '') {
          // For arrays, stringify them (and filter out 'select-all')
          if (Array.isArray(value) && value.length > 0) {
            const filteredValue = value.filter(v => v !== 'select-all');
            if (filteredValue.length > 0) {
              // Check if all options are selected - use 'all' instead of listing all values (only for multi-select)
              if (filter?.multi && filter?.options && filteredValue.length === filter.options.length) {
                const allOptionValues = filter.options.map(opt => opt.value);
                const allSelected = allOptionValues.every(val => filteredValue.includes(val));
                if (allSelected) {
                  queryParams[key] = 'all';
                } else {
                  queryParams[key] = JSON.stringify(filteredValue);
                }
              } else {
                queryParams[key] = JSON.stringify(filteredValue);
              }
            }
          } else if (!Array.isArray(value)) {
            queryParams[key] = value;
          }
        }
      });
    }

    // Update URL without reloading the page - use replaceUrl to completely replace params
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      replaceUrl: true,
    });
  }

  /**
   * Restore date filter and all other filters from URL query params on page load.
   *
   * Completed/Cancelled deliberately get NO default date window. The sidenav count badge
   * is all-time and date-free, so a 30-day default here made the table disagree with the
   * badge and hid older orders. Do not re-add one. Initial load does not depend on this
   * method — loadFilters() calls getServerData unconditionally.
   */
  private restoreDateFilterFromUrl(): void {
    const params = this.route.snapshot.queryParams;
    const startDate = params['startDate'];
    const endDate = params['endDate'];
    let shouldFetchData = false;

    // Restore date range if present in URL
    if (startDate && endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
      shouldFetchData = true;

      // Update the form controls for the date picker
      this.range.patchValue({
        start: moment(startDate, OrdersTableComponent.DATE_FORMAT),
        end: moment(endDate, OrdersTableComponent.DATE_FORMAT)
      });
    }

    // Trigger data fetch if date filters were restored and no other filters exist
    // (other filters will trigger their own fetch via applyFiltersFromUrl)
    if (shouldFetchData && !this.hasOtherFiltersInUrl(params)) {
      setTimeout(() => {
        const filters = this.getCurrentFilters();
        this.getServerData(filters.status, filters.filter);
      }, 100);
    }
  }

  /**
   * Check if URL has any filter params other than date filters
   */
  private hasOtherFiltersInUrl(params: any): boolean {
    const dateFilterKeys = ['startDate', 'endDate'];
    return Object.keys(params).some(key => !dateFilterKeys.includes(key));
  }

  /**
   * Get startDate as Date object for template display
   */
  get startDateAsDate(): Date | null {
    return this.startDate ? moment(this.startDate, OrdersTableComponent.DATE_FORMAT).toDate() : null;
  }

  /**
   * Get endDate as Date object for template display
   */
  get endDateAsDate(): Date | null {
    return this.endDate ? moment(this.endDate, OrdersTableComponent.DATE_FORMAT).toDate() : null;
  }
}

//added all components related to orders table to this file so we don't have so many folders

@Component({
    template: `<app-orders-table
    status="pending_approval"
    order-class="online"
  ></app-orders-table>`,
    standalone: false
})
export class PendingApprovalOnlineOrdersComponent { }

@Component({
    template: `<app-orders-table status="pending_cancellation" order-class="online"></app-orders-table>`,
    standalone: false
})

export class pendingCancellationOrdersComponent { }
@Component({
    template: `<app-orders-table
    status="clinic_to_review"
    order-class="online"
  ></app-orders-table>`,
    standalone: false
})
export class ClinicToReviewOnlineOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="clinic_to_action"
    order-class="online"
  ></app-orders-table>`,
    standalone: false
})
export class ClinicToActionOnlineOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="waiting_room"
    order-class="online"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class WaitingRoomOnlineOrdersComponent { }
@Component({
    template: `<app-orders-table
    status="auto_allocation"
    order-class="all_classes"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class AutoAllocationAdminOrdersComponent { }
@Component({
    template: `<app-orders-table
    status="waiting_for_information"
    order-class="online"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class WaitingForInformationOnlineOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="clinic_to_update"
    order-class="online"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class ClinicToUpateOnlineOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="price_request"
    order-class="online"
  ></app-orders-table>`,
    standalone: false
})
export class PriceRequestOnlineOrdersComponent { }

@Component({
    template: `<app-orders-table status="processing" order-class="online"></app-orders-table>`,
    standalone: false
})

export class ProcessingOnlineOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="deliverypickup"
    order-class="online"
  ></app-orders-table>`,
    standalone: false
})
export class DeliveryPickupOnlineOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="deliverypickup_driver"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class DeliveryPickupDriverOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="pending_approval_in_store"
    order-class="in_store"
  ></app-orders-table>`,
    standalone: false
})
export class PendingApprovalInStoreOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="clinic_to_review"
    order-class="in_store"
  ></app-orders-table>`,
    standalone: false
})
export class ClinicToReviewInStoreOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="clinic_to_action"
    order-class="in_store"
  ></app-orders-table>`,
    standalone: false
})
export class ClinicToActionInStoreOrdersComponent { }

@Component({
    template: `<app-orders-table status="processing" order-class="in_store"></app-orders-table>`,
    standalone: false
})
export class ProcessingInStoreOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="deliverypickup"
    order-class="in_store"
  ></app-orders-table>`,
    standalone: false
})
export class DeliveryPickupInStoreOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="clinic_to_review"
    order-class="all_classes"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class ClinicToReviewAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="care_call"
    order-class="all_classes"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class CareCallAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="clinic_to_action_admin"
    order-class="all_classes"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class ClinicToActionAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="request_issued"
    order-class="all_classes"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class RequestIssuedAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="pending_approval"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class PendingApprovalAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="price_request"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class PriceRequestAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="processing_admin"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class ProcessingAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="deliverypickup"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class DeliveryPickupAdminOrdersComponent { }

@Component({
    template: `<app-orders-table status="active" order-class="all_classes"></app-orders-table>`,
    standalone: false
})
export class ActiveAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="exception"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class ExceptionAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="pending_batch_processing"
    order-class="all_classes"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class RepeatAdminOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="completed"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class CompletedClosedOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="cancelled"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class CancelledClosedOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="telehealth_pending"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class TelehealthPendingOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="telehealth_request_issued"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class TelehealthRequestIssuedOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="telehealth_awaiting_delivery"
    order-class="all_classes"
  ></app-orders-table>`,
    standalone: false
})
export class TelehealthAwaitingDeliveryOrdersComponent { }

@Component({
    template: `<app-orders-table
    status="escalation"
    order-class="all_classes"
    [allow-bulk-action]="true"
  ></app-orders-table>`,
    standalone: false
})
export class EscalationOrdersComponent { }
